import React, { useState, useEffect, useRef } from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import debounce from 'lodash.debounce';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, MenuItem, TextField, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Chip, Snackbar, Alert, CircularProgress, useTheme, useMediaQuery, Tabs, Tab, Popover
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { exportComprobanteWorkbook, COMPROBANTE_CONFIG } from '../utils/excel/comprobanteWorkbook';
import Autocomplete from '@mui/material/Autocomplete';
import { Add, Delete, Edit, AttachFile, CloudUpload, CheckCircle, Cancel, Receipt, SwapHoriz, ReceiptLong, Close } from '@mui/icons-material';
import { GridOn } from '@mui/icons-material';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import axios from 'axios';
import Checkbox from '@mui/material/Checkbox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClienteRapidoDialog from '../components/ClienteRapidoDialog';
import ProductoRapidoDialog from '../components/ProductoRapidoDialog';
import { useResizableCols } from '../hooks/useResizableCols';
import ProductoBuscadorDialog, { StockAlmacenesDialog } from '../components/ProductoBuscadorDialog';
import { Search as SearchIcon } from '@mui/icons-material';

const COL_DEFAULTS_NV = {
  codigo:   80,
  producto: 220,
  cant:     60,
  umedida:  75,
  precio:   85,
  dscto:    70,
  total:    85,
  almacen:  120,
  acciones: 85,
};

const ResizeHandle = ({ onMouseDown }) => {
  const [hover, setHover] = useState(false);
  return (
    <span
      onMouseDown={onMouseDown}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: 'absolute', right: 0, top: 0, bottom: 0, width: 8,
        cursor: 'col-resize', userSelect: 'none',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <span style={{
        width: hover ? 3 : 2, height: hover ? '70%' : '55%', borderRadius: 1,
        background: hover ? 'rgba(25,118,210,0.7)' : 'rgba(0,0,0,0.22)',
        pointerEvents: 'none', transition: 'all 0.12s',
      }} />
    </span>
  );
};

const initialDetalle = {
  producto_id: '',
  codigo_producto: '',
  descripcion_producto: '',
  cantidad: '',
  unidad_medida: '',
  precio_unitario: 0,
  descuento_monto: 0,
  descuento_porcentaje: 0,
  subtotal: 0,
  tipo_igv: '10',
  igv_monto: 0,
  total: 0,
  observaciones: ''
};

const NotaVentaPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { widths: colW, startResize } = useResizableCols('nota-venta-detail-cols', COL_DEFAULTS_NV);
    const [openBuscadorProducto, setOpenBuscadorProducto] = useState(false);
    const [openStockAlmacen, setOpenStockAlmacen] = useState(false);
    const [copiarNombreADesc, setCopiarNombreADesc] = useState(true);
    // Estado para distinguir entre edición y nuevo
    const [modoEdicion, setModoEdicion] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [tiposIGV, setTiposIGV] = useState([]);
    const [loadingTiposIGV, setLoadingTiposIGV] = useState(false);
    
    // Estado para el diálogo de datos adicionales
    const [openDatosAdicionales, setOpenDatosAdicionales] = useState(false);

    // Estado y función para almacenes
    const [almacenes, setAlmacenes] = useState([]);
    const [almacenInput, setAlmacenInput] = useState('');
    const [loadingAlmacenes, setLoadingAlmacenes] = useState(false);

    // Función para cargar almacenes
    const fetchAlmacenes = async (query = '') => {
      setLoadingAlmacenes(true);
      try {
        const res = await axios.get('/api/almacen/mis-almacenes', { params: { q: query } });
        setAlmacenes(res.data);
        if (res.data.length === 1) {
          setDetalle(prev => ({ ...prev, almacen_id: res.data[0].id }));
        }
      } catch (err) {
        setAlmacenes([]);
      }
      setLoadingAlmacenes(false);
    };

    // Debounce para evitar muchas llamadas
    const debouncedFetchAlmacenes = React.useMemo(() => debounce(fetchAlmacenes, 300), []);

    // Función para abrir el diálogo de datos adicionales
    const handleOpenDatosAdicionales = async () => {
      // Buscar el id correcto de la nota de venta
      const nvId = form.id;
      if (nvId && nvId !== datosCargadosParaId.current) {
        try {
          const [resPlaca, resOC] = await Promise.all([
            axios.get(`/api/datos-adicionales/NOTA_VENTA/${nvId}/placa`).catch(() => null),
            axios.get(`/api/datos-adicionales/NOTA_VENTA/${nvId}/orden_compra`).catch(() => null)
          ]);
          setPlacaAdicional(resPlaca?.data?.valor || '');
          setOrdenCompraAdicional(resOC?.data?.valor || '');
          datosCargadosParaId.current = nvId;
        } catch {
          setPlacaAdicional('');
          setOrdenCompraAdicional('');
        }
      }
      setOpenDatosAdicionales(true);
    };
    // Función para cargar tipos IGV (debe ir antes del useEffect)
    const fetchTiposIGV = async () => {
    setLoadingTiposIGV(true);
    try {
        const res = await axios.get('/api/tipo-igv');
        setTiposIGV(res.data);
    } catch (err) {
        setTiposIGV([]);
    }
    setLoadingTiposIGV(false);
    };
    // Función para cargar condiciones de pago (debe ir antes del useEffect)
    const fetchCondicionesPago = async () => {
      setLoadingCondicionesPago(true);
      try {
        const res = await axios.get('/api/condicion-pago');
        setCondicionesPago(res.data);
        // Autoseleccionar Contado si existe
        const contado = res.data.find(c => c.descripcion.toLowerCase() === 'contado');
        if (contado) {
          setForm(f => ({ ...f, condicion_pago: contado.id }));
        }
      } catch (err) {
        setCondicionesPago([]);
      }
      setLoadingCondicionesPago(false);
    };
    const [notasVenta, setNotasVenta] = useState([]);
    const [open, setOpen] = useState(false);
    const [verNotaVenta, setVerNotaVenta] = useState(null);
    const [form, setForm] = useState({
        serie: '',
        numero: '',
        fecha_emision: new Date().toLocaleDateString('en-CA'),
        fecha_validez: '',
        cliente_id: '',
        vendedor_id: '',
        moneda: 'PEN',
        tipo_cambio: 1,
        condicion_pago: 'CONTADO',
        cuotas_json: '',
        subtotal: 0,
        descuento_global: 0,
        porcentaje_descuento_global: 0,
        total_igv: 0,
        total: 0,
        observaciones: '',
        estado: 'PENDIENTE',
        detalles: [],
        adjuntos: [],
        sucursal_id: ''
    });
    const [detalle, setDetalle] = useState(initialDetalle);
    const [editingDetalle, setEditingDetalle] = useState(null);
    const [clientes, setClientes] = useState([]);
    const [clienteInput, setClienteInput] = useState('');
    const [loadingClientes, setLoadingClientes] = useState(false);
    const [openNuevoCliente, setOpenNuevoCliente] = useState(false);
    const [openNuevoProducto, setOpenNuevoProducto] = useState(false);
    const [productoInput, setProductoInput] = useState('');
    // Solo mostrar el usuario logueado como vendedor
    const [vendedores, setVendedores] = useState([]);
    const [productos, setProductos] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [condicionesPago, setCondicionesPago] = useState([]);
    const [loadingCondicionesPago, setLoadingCondicionesPago] = useState(false);
    const [monedaInput, setMonedaInput] = useState('');
    const [loadingMonedas, setLoadingMonedas] = useState(false);
    const [adjuntos, setAdjuntos] = useState([]);
    const [series, setSeries] = useState([]);
    const [serieInput, setSerieInput] = useState('');
    const [loadingSeries, setLoadingSeries] = useState(false);
    const [sucursales, setSucursales] = useState([]);
    const [sucursalInput, setSucursalInput] = useState('');
    const [loadingSucursales, setLoadingSucursales] = useState(false);
    const [unidades, setUnidades] = useState([]);
    const [detalleError, setDetalleError] = useState({ producto: false, cantidad: false, unidad_medida: false });
    const [detalleErrorMsg, setDetalleErrorMsg] = useState('');
    const [stockDisponible, setStockDisponible] = useState(null);
    const [preciosIncluyenIgv, setPreciosIncluyenIgv] = useState(false);
    // Estados para el modal de cotizaciones
    const [openCotizaciones, setOpenCotizaciones] = useState(false);
    const [cotizacionesDisponibles, setCotizacionesDisponibles] = useState([]);
    const [cotizacionesSeleccionadas, setCotizacionesSeleccionadas] = useState([]);
    // Filtro universal de búsqueda
    const [filtroCotizacion, setFiltroCotizacion] = useState('');
    const [vistaCotizacion, setVistaCotizacion] = useState(null);
    const [filtroCotizacionInput, setFiltroCotizacionInput] = useState('');
    // Paginado para cotizaciones
    const [cotizacionesPage, setCotizacionesPage] = useState(0);
    const [cotizacionesRowsPerPage, setCotizacionesRowsPerPage] = useState(4);
    // Pestañas del popup de referencias: 0 = Disponibles, 1 = Ya referenciado
    const [refTab, setRefTab] = useState(0);
    const [refInfoAnchor, setRefInfoAnchor] = useState(null);
    const [refInfoTexto, setRefInfoTexto] = useState('');

    // Estado para búsqueda
    const [search, setSearch] = useState("");

    // Estado para conversión NV → Factura/Boleta
    const [nvConvertirDialog, setNvConvertirDialog] = useState(false);
    const [nvConvertirDoc, setNvConvertirDoc] = useState(null);
    const [nvConvertirTipo, setNvConvertirTipo] = useState('FACTURA');
    const [nvConvertirSerie, setNvConvertirSerie] = useState('');
    const [nvSeriesConversion, setNvSeriesConversion] = useState([]);
    const [nvConvertirLoading, setNvConvertirLoading] = useState(false);
    const [nvSnackbar, setNvSnackbar] = useState({ open: false, msg: '', severity: 'success' });

    const [openNvPdfDialog, setOpenNvPdfDialog] = useState(false);
    const [nvPdfTarget, setNvPdfTarget] = useState(null);
    const [nvPdfFormatoSeleccionado, setNvPdfFormatoSeleccionado] = useState(() => localStorage.getItem('nota_venta_pdf_formato_default') || 'A4');
    const [guardarNvPdfComoPredeterminado, setGuardarNvPdfComoPredeterminado] = useState(true);
    const [nvPdfResolucion, setNvPdfResolucion] = useState({});
    const [nvPdfResolucionCargando, setNvPdfResolucionCargando] = useState(false);

    const actualizarResolucionFormatoNv = async (nuevoFormato) => {
      if (!nvPdfTarget) return;
      setNvPdfResolucionCargando(true);
      try {
        const res = await axios.get(`/api/reporte-pdf/resuelve-nota-venta/${nvPdfTarget.id}`, { params: { formato: nuevoFormato } });
        setNvPdfResolucion(res.data || {});
      } catch (err) {
        console.error('Error resolving NV PDF template:', err);
      } finally {
        setNvPdfResolucionCargando(false);
      }
    };

    const abrirDialogoPdfNv = async (nv) => {
      const formatoGuardado = localStorage.getItem('nota_venta_pdf_formato_default') || 'A4';
      setNvPdfTarget(nv);
      setNvPdfFormatoSeleccionado(formatoGuardado);
      setGuardarNvPdfComoPredeterminado(true);
      setNvPdfResolucion({});
      setOpenNvPdfDialog(true);
      setNvPdfResolucionCargando(true);
      try {
        const res = await axios.get(`/api/reporte-pdf/resuelve-nota-venta/${nv.id}`, { params: { formato: formatoGuardado } });
        setNvPdfResolucion(res.data || {});
      } catch (err) {
        console.error('Error resolving NV PDF template:', err);
      } finally {
        setNvPdfResolucionCargando(false);
      }
    };

    const cerrarDialogoPdfNv = () => {
      setOpenNvPdfDialog(false);
      setNvPdfTarget(null);
    };

    const descargarPdfNv = () => {
      if (!nvPdfTarget) return;
      const formato = String(nvPdfFormatoSeleccionado || 'A4').toUpperCase();
      if (guardarNvPdfComoPredeterminado) {
        localStorage.setItem('nota_venta_pdf_formato_default', formato);
      }
      const tk = localStorage.getItem('token') || '';
      const query = new URLSearchParams({ formato, mode: 'inline', _ts: Date.now() }).toString();
      window.open(`/api/reporte-pdf/nota-venta/${nvPdfTarget.id}?${query}&token=${tk}`, '_blank');
      cerrarDialogoPdfNv();
    };

    const fetchNvSeriesConversion = async (tipo) => {
      try {
        const res = await axios.get('/api/series');
        const filtered = res.data.filter(s =>
          tipo === 'FACTURA' ? (/^F/i.test(s.serie) || s.tipo_documento === '01') : (/^B/i.test(s.serie) || s.tipo_documento === '03')
        );
        setNvSeriesConversion(filtered);
        setNvConvertirSerie(filtered.length > 0 ? filtered[0].serie : '');
      } catch { setNvSeriesConversion([]); setNvConvertirSerie(''); }
    };

    const handleNvConvertirTipo = (tipo) => {
      setNvConvertirTipo(tipo);
      fetchNvSeriesConversion(tipo);
    };

    const handleNvConvertir = async () => {
      if (!nvConvertirSerie || !nvConvertirDoc) return;
      setNvConvertirLoading(true);
      try {
        const res = await axios.post(`/api/nota-venta/${nvConvertirDoc.id}/convertir`, { tipo: nvConvertirTipo, serie: nvConvertirSerie });
        setNvConvertirDialog(false);
        fetchNotasVenta();
        const label = nvConvertirTipo === 'FACTURA' ? 'Factura' : 'Boleta';
        setNvSnackbar({ open: true, msg: `${label} ${res.data.serie}-${String(res.data.numero).padStart(8, '0')} creada exitosamente`, severity: 'success' });
      } catch (err) {
        setNvSnackbar({ open: true, msg: err.response?.data?.error || 'Error al convertir Nota de Venta', severity: 'error' });
      }
      setNvConvertirLoading(false);
    };

    // Obtener el usuario logueado (ejemplo: desde localStorage o contexto)
    const usuarioLogueado = JSON.parse(localStorage.getItem('usuario'));

    // Buscar tipo de cambio al cambiar la fecha de emisión si la moneda es USD
    const handleFechaEmisionChange = async (e) => {
        const nuevaFecha = e.target.value;
        setForm(prevForm => {
        const nuevoForm = { ...prevForm, fecha_emision: nuevaFecha };
        // Si la moneda ya es USD, consultar tipo de cambio
        if (nuevoForm.moneda === 'USD') {
            consultarTipoCambio(nuevaFecha);
        }
        return nuevoForm;
        });
    };

  // Función auxiliar para consultar tipo de cambio
  const consultarTipoCambio = async (fecha) => {
    try {
      const resBD = await axios.get('/api/tipo-cambio');
      const tc = resBD.data.find(x => x.fecha && x.fecha.substring(0,10) === fecha);
      if (tc && tc.venta) {
        setForm(f => ({ ...f, tipo_cambio: tc.venta }));
        return;
      }
    } catch {}
    try {
      const res = await axios.get(`/api/tipo-cambio/sunat?fecha=${fecha}`);
      if (res.data && res.data.venta) {
        setForm(f => ({ ...f, tipo_cambio: res.data.venta }));
        return;
      }
    } catch {}
    setForm(f => ({ ...f, tipo_cambio: 1 }));
  };

  console.log('usuarioLogueado:', usuarioLogueado);

    // Función para cargar cotizaciones filtradas
    // Reutiliza la lógica de Cotizacion.js
    const fetchCotizaciones = async () => {
      let query = filtroCotizacion.trim();
      let url = '/api/cotizacion?';
      if (query) url += `search=${encodeURIComponent(query)}&`;
      try {
        const res = await axios.get(url);
        let cotizaciones = res.data || [];
        // Marcar cada cotización: ¿alguna de sus líneas ya fue referenciada por
        // otro documento (NV/Guía/Factura/Boleta)? — vía saldo_cantidad.
        cotizaciones = cotizaciones.map(cot => {
          const dets = Array.isArray(cot.detalles) ? cot.detalles : [];
          const refsLinea = dets.map(d => d.referenciado_por).filter(Boolean);
          const tieneReferencia = dets.some(d =>
            d.referenciado_por || (d.saldo_cantidad != null && Number(d.saldo_cantidad) < Number(d.cantidad) - 0.0001)
          );
          const referenciasResumen = [...new Set(refsLinea.flatMap(r => r.split(' | ')))].join(', ');
          return { ...cot, _tieneReferencia: tieneReferencia, _referenciasResumen: referenciasResumen };
        });
        // Separar por pestaña (Disponibles / Ya referenciado) y luego paginar
        cotizaciones = cotizaciones.filter(c => (refTab === 1) === c._tieneReferencia);
        const start = cotizacionesPage * cotizacionesRowsPerPage;
        const end = start + cotizacionesRowsPerPage;
        cotizaciones = cotizaciones.slice(start, end);
        setCotizacionesDisponibles(cotizaciones);
      } catch (e) {
        setCotizacionesDisponibles([]);
      }
    };

    // Al abrir el modal, limpiar selección y filtrar cotizaciones disponibles
    useEffect(() => {
    if (openCotizaciones) {
        setCotizacionesSeleccionadas([]);
          const cotizacionesJaladas = form.detalles.map(d => d.cotizacion_id); // Filtrar cotizaciones que ya están en el detalle
          if (form.cliente_id) { // Si hay cliente, filtra por su número de documento
            const cliente = clientes.find(c => c.id === form.cliente_id);
            if (cliente && cliente.numero_documento) {
              setFiltroCotizacion(cliente.numero_documento);
              setFiltroCotizacionInput(cliente.numero_documento);
            }
          }
          setCotizacionesPage(0);
          setRefTab(0);
          fetchCotizaciones(); // Siempre llama para mostrar el listado
    }
    }, [openCotizaciones]);

    // Al cambiar filtro, pestaña o paginado, recargar cotizaciones
    useEffect(() => {
    if (openCotizaciones) fetchCotizaciones();
    }, [filtroCotizacion, cotizacionesPage, cotizacionesRowsPerPage, refTab]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setFiltroCotizacion(filtroCotizacionInput);
            setCotizacionesPage(0); // Reinicia paginado al buscar
        }, 300);
        return () => clearTimeout(handler);
    }, [filtroCotizacionInput]);

    useEffect(() => {
        fetchTiposIGV();
        fetchNotasVenta();
        fetchProductos();
        fetchCondicionesPago();
        fetchUnidades();
        fetchClientesAsync("");
        fetchAlmacenes();
        setModoEdicion(false); // Desactivar modo edición en carga inicial
    }, []);

    useEffect(() => {
        fetchNotasVenta(); 
    }, [search]);
    
    useEffect(() => {
        if (open) {
        fetchVendedoresAsync();
        fetchAlmacenes();
        }
    }, [open]);
    // Búsqueda asíncrona de almacenes en el Autocomplete
    useEffect(() => {
      if (almacenInput !== '') {
        debouncedFetchAlmacenes(almacenInput);
      } else if (open) {
        fetchAlmacenes();
      }
    }, [almacenInput, open]);

    const fetchUnidades = async () => {
        try {
        const res = await axios.get('/api/unidades');
        setUnidades(res.data);
        } catch (err) {
        setUnidades([]);
        }
    };

  const fetchNotasVenta = async () => {
    try {
      const res = await axios.get('/api/nota-venta/general', { params: { search } }); //const res = await axios.get('/api/nota-venta', { params: { search } });
      setNotasVenta(res.data);
    } catch (err) {
      console.error('Error al obtener notas de venta:', err);
      if (window && window.console) window.console.log('NOTA VENTA ERROR:', err);
      alert('Error al obtener notas de venta: ' + (err.response?.data?.error || err.message));
    }
  };
  // Búsqueda asíncrona de clientes
  const fetchClienteGenRef = React.useRef(0);
  const fetchClientesAsync = async (query = '') => {
    const gen = ++fetchClienteGenRef.current;
    setLoadingClientes(true);
    try {
      const res = await axios.get('/api/auxiliares', {
        params: { tipo: 'CLIENTE', q: query }
      });
      if (gen === fetchClienteGenRef.current) setClientes(res.data);
    } catch (err) {
      console.error('Error al buscar clientes:', err);
      if (gen === fetchClienteGenRef.current) setClientes([]);
    }
    if (gen === fetchClienteGenRef.current) setLoadingClientes(false);
  };

  // Debounce para evitar muchas llamadas
  const debouncedFetchClientes = React.useMemo(() => debounce(fetchClientesAsync, 300), []);
  const skipClienteSearch = React.useRef(false);
  const fetchVendedores = async () => {
    try {
      const res = await axios.get('/api/usuarios');
      setVendedores(res.data);
    } catch (err) {
      console.error('Error al obtener vendedores:', err);
      alert('Error al obtener vendedores: ' + (err.response?.data?.error || err.message));
    }
  };
  const fetchProductos = async (q = '') => {
    try {
      const params = {};
      if (form.sucursal_id) params.sucursal_id = form.sucursal_id;
      if (q) { params.search = q; params.limit = 60; }
      else if (form.sucursal_id) { params.limit = 5000; }
      const res = await axios.get('/api/productos', { params });
      setProductos(res.data);
    } catch (err) {
      console.error('Error al obtener productos:', err);
      alert('Error al obtener productos: ' + (err.response?.data?.error || err.message));
    }
  };
  const debouncedFetchProductos = React.useMemo(() => debounce(fetchProductos, 300), [form.sucursal_id]);

  // Re-cargar productos filtrados cuando cambia la sucursal seleccionada
  useEffect(() => {
    if (form.sucursal_id) fetchProductos();
  }, [form.sucursal_id]);

  // Stock check: fetch when producto + almacen are set and category afecta_kardex
  useEffect(() => {
    const productoId = detalle.producto_id;
    const almacenId  = detalle.almacen_id;
    if (!productoId || !almacenId) { setStockDisponible(null); return; }
    const prod = productos.find(p => p.id === productoId);
    if (!prod || !prod.afecta_kardex) { setStockDisponible(null); return; }
    let cancelled = false;
    axios.get(`/api/kardex/stock/${productoId}/${almacenId}`)
      .then(res => { if (!cancelled) setStockDisponible(res.data.stock ?? 0); })
      .catch(() => { if (!cancelled) setStockDisponible(null); });
    return () => { cancelled = true; };
  }, [detalle.producto_id, detalle.almacen_id, productos]);

  const fetchMonedasAsync = async (query = '') => {
    setLoadingMonedas(true);
    try {
      const res = await axios.get('/api/monedas', {
        params: { q: query }
      });
      setMonedas(res.data);
    } catch (err) {
      console.error('Error al buscar monedas:', err);
      setMonedas([]);
    }
    setLoadingMonedas(false);
  };

  const debouncedFetchMonedas = React.useMemo(() => debounce(fetchMonedasAsync, 300), []);

  const fetchSucursalesAsync = async (query = '') => {
    setLoadingSucursales(true);
    try {
      const res = await axios.get('/api/sucursales/mis-sucursales', { params: { q: query } });
      setSucursales(res.data);
      // Seleccionar la primera sucursal por defecto solo en carga inicial (sin filtro)
      if (query === '' && res.data.length > 0) {
        setForm(f => ({ ...f, sucursal_id: f.sucursal_id || res.data[0].id }));
      }
    } catch (err) {
      console.error('Error al buscar sucursales:', err);
      setSucursales([]);
    }
    setLoadingSucursales(false);
  };

  const debouncedFetchSucursales = React.useMemo(() => debounce(fetchSucursalesAsync, 300), []);

  useEffect(() => {
    if (open) {
      fetchSucursalesAsync(''); // cargar inicial
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    if (sucursalInput !== '') {
      debouncedFetchSucursales(sucursalInput);
    } else {
      fetchSucursalesAsync('');
    }
  }, [sucursalInput]);

  // Filtrar series por sucursal y permisos SOLO tipo NTV (Nota de Venta)
  const fetchSeriesPorSucursalYUsuario = async (idSucursal, idUsuario) => {
    setLoadingSeries(true);
    try {
      // Series de la sucursal
      const resSeries = await axios.get(`/api/series/sucursal/${idSucursal}`);
      // Series permitidas para el usuario
      const resPermisos = await axios.get(`/api/usuario-serie/${idUsuario}`);
      const seriesPermitidas = resSeries.data.filter(serie =>
        serie.tipo_documento === 'NV' &&
        resPermisos.data.some(perm => perm.id === serie.id && perm.activo)
      );
      setSeries(seriesPermitidas);
      // Seleccionar la primera serie por defecto SOLO si NO está en modo edición
      if (!modoEdicion) {
        if (seriesPermitidas.length > 0) {
          setForm(f => ({ ...f, serie: seriesPermitidas[0].serie, numero: seriesPermitidas[0].correlativo_actual }));
        } else {
          setForm(f => ({ ...f, serie: '', numero: '' }));
        }
      }
    } catch (err) {
      console.error('Error al buscar series:', err);
      setSeries([]);
    }
    setLoadingSeries(false);
  };

  // Cuando cambia sucursal, cargar series filtradas por usuario
  useEffect(() => {
    if (form.sucursal_id && form.vendedor_id) {
      fetchSeriesPorSucursalYUsuario(form.sucursal_id, form.vendedor_id);
      // Al cargar series y correlativo, solo actualizar correlativo si NO está en modo edición
      if (!modoEdicion && series.length > 0) {
        // Setear correlativo automáticamente usando la primera serie permitida
        setForm(prev => ({
          ...prev,
          serie: series[0].nombre || series[0].codigo || '',
          numero: series[0].correlativo || '',
        }));
      }
      // Si está en modo edición, NO actualizar el correlativo
    }
  }, [form.sucursal_id, form.vendedor_id]);

  const handleOpen = async () => {
    setModoEdicion(false);
    setAdjuntos([]);
    setFiltroCotizacionInput('');
    setFiltroCotizacion('');
    setCotizacionesSeleccionadas([]);
    // Forzar recarga de vendedores antes de abrir el formulario
    await fetchVendedoresAsync(); // Usar fetchVendedoresAsync
    // Obtener configuración de empresa para el valor por defecto de preciosIncluyenIgv
    try {
      const { obtenerEmpresaConfig } = await import('../utils/empresaConfig');
      const config = await obtenerEmpresaConfig();
      if (config && (config.precios_incluyen_igv === 1 || config.precios_incluyen_igv === true)) {
        setPreciosIncluyenIgv(true);
      } else {
        setPreciosIncluyenIgv(false);
      }
    } catch (err) {
      setPreciosIncluyenIgv(false);
    }
    // Seleccionar automáticamente el vendedor logueado
    if (usuarioLogueado) {
      setForm(f => ({
        ...f,
        detalles: [],
        adjuntos: [],
        fecha_emision: new Date().toLocaleDateString('en-CA'),
        fecha_validez: '',
        vendedor_id: usuarioLogueado.id,
        cliente_id: '', // Limpiar cliente al abrir nueva cotización
        moneda: 'PEN', // No arrastrar moneda de un comprobante editado previamente
        tipo_cambio: 1,
        condicion_pago: (condicionesPago.find(c => c.descripcion?.toLowerCase() === 'contado') || {}).id || '',
        subtotal: 0,
        total_igv: 0,
        total: 0,
        serie: '',   // Limpiar serie
        numero: '',  // Limpiar correlativo
        observaciones: '', // Limpiar observaciones
      }));
    } else {
      setForm(f => ({
        ...f,
        detalles: [],
        adjuntos: [],
        fecha_emision: new Date().toLocaleDateString('en-CA'),
        fecha_validez: '',
        vendedor_id: '',
        cliente_id: '', // Limpiar cliente al abrir nueva cotización
        moneda: 'PEN', // No arrastrar moneda de un comprobante editado previamente
        tipo_cambio: 1,
        condicion_pago: (condicionesPago.find(c => c.descripcion?.toLowerCase() === 'contado') || {}).id || '',
        subtotal: 0,
        total_igv: 0,
        total: 0,
        serie: '',   // Limpiar serie
        numero: '',  // Limpiar correlativo
        observaciones: '', // Limpiar observaciones
      }));
    }

    // Esperar un ciclo para asegurar que el form se limpió antes de asignar la serie
    setTimeout(() => {
      fetchSeriesPorSucursalYUsuario(form.sucursal_id, form.vendedor_id);
      if (!modoEdicion && series.length > 0) {
        // Setear correlativo automáticamente usando la primera serie permitida
        setForm(prev => ({
          ...prev,
          serie: series[0].nombre || series[0].codigo || '',
          numero: series[0].correlativo || '',
        }));
      }
    }, 0);
    //setModoEdicion(true); // Activar modo edición al abrir para editar
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setForm(prev => ({ ...prev, detalles: [], adjuntos: [] }));
    setDetalle(initialDetalle);
    setEditingDetalle(null);
    setModoEdicion(false);
    setPlacaAdicional('');
    setOrdenCompraAdicional('');
    datosCargadosParaId.current = null;
    setFiltroCotizacionInput('');
    setFiltroCotizacion('');
    setCotizacionesSeleccionadas([]);
  };

  const handleFormChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleDetalleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'producto_id') {
      const prod = productos.find(p => p.id === value);
      setDetalle({
        ...detalle,
        producto_id: value,
        codigo_producto: prod?.codigo || '',
        descripcion_producto: copiarNombreADesc ? (prod?.nombre || '') : '',
        unidad_medida: prod && prod.unidad_medida_id ? prod.unidad_medida_id : '',
        precio_unitario: prod && prod.precio != null ? prod.precio : detalle.precio_unitario
      });
    } else {
      setDetalle({ ...detalle, [name]: value });
    }
    setDetalleError({ producto: false, cantidad: false, unidad_medida: false, almacen: false });
    setDetalleErrorMsg('');
  };

  const handleBuscadorSelect = (prod) => {
    setProductoInput(prod?.nombre || '');
    setDetalle(d => ({
      ...d,
      producto_id: prod.id,
      codigo_producto: prod.codigo || '',
      descripcion_producto: copiarNombreADesc ? (prod.nombre || '') : d.descripcion_producto,
      precio_unitario: prod.precio != null ? prod.precio : d.precio_unitario,
      unidad_medida: prod.unidad_medida_id ? prod.unidad_medida_id : d.unidad_medida,
    }));
    setDetalleError(e => ({ ...e, producto: false }));
    setDetalleErrorMsg('');
  };

  const calcularDetalle = (d) => {
    const cantidad = parseFloat(d.cantidad) || 0;
    const precio = parseFloat(d.precio_unitario) || 0;
    const desc = parseFloat(d.descuento_monto) || 0;
    const descP = parseFloat(d.descuento_porcentaje) || 0;
    const tasaIgv = 0.18;
    const tipoIGV = Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === d.tipo_igv) : undefined;
    let subtotal = 0, igv = 0, total = 0;
    // Códigos gratuitos según tabla SUNAT
    const codigosGratuitos = ['21', '31', '32', '33', '34', '35'];
    const esGratuito = tipoIGV && codigosGratuitos.includes(tipoIGV.codigo);
    // Códigos gravados
    const codigosGravados = ['10','11','12','13','14','15','16','17'];
    // Códigos exonerados
    const codigosExonerados = ['20','21'];
    // Códigos inafectos
    const codigosInafectos = ['30','31','32','33','34','35','36'];
    // Código exportación
    const codigosExportacion = ['40'];
    if (esGratuito) {
      subtotal = Math.round((precio * cantidad - desc - (precio * cantidad * descP / 100)) * 10000) / 10000;
      igv = 0;
      total = 0;
    } else if (preciosIncluyenIgv && tipoIGV && codigosGravados.includes(tipoIGV.codigo)) {
      const precioFinal = precio * cantidad - desc - (precio * cantidad * descP / 100);
      subtotal = Math.round((precioFinal / (1 + tasaIgv)) * 10000) / 10000;
      igv = Math.round((precioFinal - subtotal) * 10000) / 10000;
      total = Math.round(precioFinal * 10000) / 10000;
    } else {
      subtotal = Math.round((precio * cantidad - desc - (precio * cantidad * descP / 100)) * 10000) / 10000;
      if (tipoIGV && codigosGravados.includes(tipoIGV.codigo)) {
        igv = Math.round(subtotal * tasaIgv * 10000) / 10000;
      } else {
        igv = 0;
      }
      total = Math.round((subtotal + igv) * 10000) / 10000;
    }
    return { ...d, subtotal, igv_monto: igv, total };
  };
  // Estado para mostrar/ocultar el resumen por tipo de IGV
  const [mostrarResumenIGV, setMostrarResumenIGV] = useState(false);

  const agregarDetalle = () => {
    let error = false;
    let errorObj = { producto: false, cantidad: false, unidad_medida: false, almacen: false };
    let errorMsg = '';
    if (!detalle.producto_id) {
      error = true;
      errorObj.producto = true;
      errorMsg = 'Debes seleccionar un producto.';
    }
    if (!detalle.cantidad || isNaN(detalle.cantidad) || Number(detalle.cantidad) <= 0) {
      error = true;
      errorObj.cantidad = true;
      errorMsg = errorMsg ? 'Selecciona un producto y una cantidad mayor a 0.' : 'La cantidad debe ser mayor a 0.';
    }
    if (!detalle.unidad_medida) {
      error = true;
      errorObj.unidad_medida = true;
      errorMsg = errorMsg ? 'Selecciona producto, cantidad y unidad de medida.' : 'Debes seleccionar una unidad de medida.';
    }
    if (!detalle.almacen_id) {
      error = true;
      errorObj.almacen = true;
      errorMsg = errorMsg ? 'Selecciona producto, cantidad, unidad de medida y almacén.' : 'Debes seleccionar un almacén.';
    }
    if (error) {
      setDetalleError(errorObj);
      setDetalleErrorMsg(errorMsg);
      return;
    }
    // Validación de stock si categoría afecta kardex
    if (stockDisponible !== null) {
      const cantEnGrid = form.detalles
        .filter(d => d.producto_id === detalle.producto_id && d.almacen_id === detalle.almacen_id)
        .reduce((s, d) => s + Number(d.cantidad || 0), 0);
      if (cantEnGrid + Number(detalle.cantidad) > Number(stockDisponible)) {
        setDetalleError(e => ({ ...e, cantidad: true }));
        setDetalleErrorMsg(cantEnGrid > 0
          ? `Stock insuficiente. Ya tiene ${cantEnGrid.toFixed(2)} de este producto en la grilla. Disponible: ${parseFloat(stockDisponible).toFixed(2)} unidades.`
          : `Stock insuficiente. Disponible en almacén: ${parseFloat(stockDisponible).toFixed(2)} unidades.`);
        return;
      }
    }

    // Si la descripción está vacía, usar el nombre del producto seleccionado
    let descripcionFinal = detalle.descripcion_producto;
    if (!descripcionFinal) {
      const prod = productos.find(p => p.id === detalle.producto_id);
      descripcionFinal = prod && prod.nombre ? prod.nombre : '';
    }
    // Obtener objeto de unidad de medida
    const unidadObj = unidades.find(u => u.id === detalle.unidad_medida);
    const almacenObj = almacenes.find(a => a.id === detalle.almacen_id);

    const det = calcularDetalle({
      ...detalle,
      descripcion_producto: descripcionFinal,
      unidad_medida_id: unidadObj ? unidadObj.id : null,
      unidad_medida: unidadObj ? unidadObj.abreviatura : '',
      almacen_id: almacenObj ? almacenObj.id : ''
    });
    setForm(prev => ({ ...prev, detalles: [...prev.detalles, det] }));
    setDetalle(almacenes.length === 1 ? { ...initialDetalle, almacen_id: almacenes[0].id } : initialDetalle);
    setProductoInput('');
    fetchProductos();
    setEditingDetalle(null);
    setStockDisponible(null);
    setDetalleError({ producto: false, cantidad: false, unidad_medida: false, almacen: false });
    setDetalleErrorMsg('');
  };

  const editarDetalle = (idx) => {
    const d = form.detalles[idx];
    // Buscar el objeto de unidad de medida por id o abreviatura
    let unidadObj = null;
    if (d.unidad_medida_id) {
      unidadObj = unidades.find(u => u.id === d.unidad_medida_id);
    } else if (d.unidad_medida) {
      unidadObj = unidades.find(u => u.abreviatura === d.unidad_medida || u.id === d.unidad_medida);
    }
    setDetalle({
      ...d,
      unidad_medida: unidadObj ? unidadObj.id : '',
      unidad_medida_id: unidadObj ? unidadObj.id : null
    });
    // Seleccionar el almacén en el formulario principal
    if (d.almacen_id) {
      setForm(f => ({ ...f, almacen_id: d.almacen_id }));
    }
    setProductoInput(productos.find(p => p.id === d.producto_id)?.nombre || '');
    setEditingDetalle(idx);
  };

  const actualizarDetalle = () => {
    if (!detalle.almacen_id) {
      setDetalleError(e => ({ ...e, almacen: true }));
      setDetalleErrorMsg('Debes seleccionar un almacén.');
      return;
    }
    if (stockDisponible !== null) {
      const cantEnGrid = form.detalles
        .filter((d, idx) => d.producto_id === detalle.producto_id && d.almacen_id === detalle.almacen_id && idx !== editingDetalle)
        .reduce((s, d) => s + Number(d.cantidad || 0), 0);
      if (cantEnGrid + Number(detalle.cantidad) > Number(stockDisponible)) {
        setDetalleError(e => ({ ...e, cantidad: true }));
        setDetalleErrorMsg(cantEnGrid > 0
          ? `Stock insuficiente. Otras filas ya usan ${cantEnGrid.toFixed(2)} unidades. Disponible: ${parseFloat(stockDisponible).toFixed(2)} unidades.`
          : `Stock insuficiente. Disponible en almacén: ${parseFloat(stockDisponible).toFixed(2)} unidades.`);
        return;
      }
    }
    setDetalleError({ producto: false, cantidad: false, unidad_medida: false, almacen: false });
    setDetalleErrorMsg('');
    let descripcionFinal = detalle.descripcion_producto;
    if (!descripcionFinal) {
      const prod = productos.find(p => p.id === detalle.producto_id);
      descripcionFinal = prod && prod.nombre ? prod.nombre : '';
    }
    const unidadObj = unidades.find(u => u.id === detalle.unidad_medida);
    const almacenObj = almacenes.find(a => a.id === detalle.almacen_id);
    const det = calcularDetalle({
      ...detalle,
      descripcion_producto: descripcionFinal,
      unidad_medida_id: unidadObj ? unidadObj.id : null,
      unidad_medida: unidadObj ? unidadObj.abreviatura : '',
      almacen_id: almacenObj ? almacenObj.id : '',
    });
    setForm(prev => ({ ...prev, detalles: prev.detalles.map((d, idx) => idx === editingDetalle ? det : d) }));
    setDetalle(almacenes.length === 1 ? { ...initialDetalle, almacen_id: almacenes[0].id } : initialDetalle);
    setProductoInput('');
    fetchProductos();
    setStockDisponible(null);
    setEditingDetalle(null);
  };

  const eliminarDetalle = (idx) => {
    setForm(prev => ({ ...prev, detalles: prev.detalles.filter((_, i) => i !== idx) }));
  };

  const handleAdjunto = (e) => {
    const files = Array.from(e.target.files);
    setAdjuntos([...adjuntos, ...files]);
    setForm(prev => ({ ...prev, adjuntos: [...prev.adjuntos, ...files] }));
  };

  const calcularTotales = () => {
    // Definir códigos según tabla SUNAT
    const codigosGravados = ['10','11','12','13','14','15','16','17'];
    const codigosExonerados = ['20','21'];
    const codigosInafectos = ['30','31','32','33','34','35','36'];
    const codigosExportacion = ['40'];
    const codigosGratuitos = ['21','31','32','33','34','35'];

    let subtotal = 0, total_igv = 0, total = 0;
    let total_gravada = 0, total_exonerada = 0, total_inafecta = 0, total_gratuita = 0, total_exportacion = 0;
    let total_otros_cargos = 0, total_icbper = 0, total_anticipos = 0, total_percepcion = 0, total_otros_impuestos = 0;

    form.detalles.forEach(d => {
      const tipoIGV = Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === d.tipo_igv) : undefined;
      // Fallback a d.tipo_igv directo cuando tiposIGV aun no cargo (evita que
      // total_gravada quede en 0 mientras total_igv/total si se calculan bien).
      const cod = tipoIGV?.codigo || d.tipo_igv;
      const montoTotal = parseFloat(d.total) || 0;
      const montoSubtotal = parseFloat(d.subtotal) || 0;
      // Sumar por tipo (base imponible = subtotal sin IGV)
      if (codigosGravados.includes(cod)) total_gravada += montoSubtotal;
      if (codigosExonerados.includes(cod)) total_exonerada += montoSubtotal;
      if (codigosInafectos.includes(cod)) total_inafecta += montoSubtotal;
      if (codigosExportacion.includes(cod)) total_exportacion += montoSubtotal;
      if (codigosGratuitos.includes(cod)) total_gratuita += montoSubtotal;
      // Sumar totales generales (solo si NO es gratuito)
      if (!codigosGratuitos.includes(cod)) {
        subtotal += montoSubtotal;
        total_igv += parseFloat(d.igv_monto) || 0;
        total += montoTotal;
      }
    });
    setForm(f => ({
      ...f,
      subtotal,
      total_igv,
      total,
      total_gravada,
      total_exonerada,
      total_inafecta,
      total_gratuita,
      total_exportacion,
      total_otros_cargos,
      total_icbper,
      total_anticipos,
      total_percepcion,
      total_otros_impuestos
    }));
  };

  useEffect(() => {
    if (form.detalles.length > 0) calcularTotales();
  }, [form.detalles]);

  const handleSubmit = async () => {
    if (guardando) return; // Evita doble envío por doble clic mientras se está grabando
    setGuardando(true);
    try {
    if (!form.detalles || form.detalles.length === 0) {
      alert('Debe agregar al menos un producto o servicio al detalle antes de guardar.');
      return;
    }
    const itemsSinProducto = form.detalles.filter(d => !d.producto_id);
    if (itemsSinProducto.length > 0) {
      const descripciones = itemsSinProducto.map(d => d.descripcion_producto || d.descripcion || '(sin descripción)').join(', ');
      alert(`Falta seleccionar un producto para: ${descripciones}. Esto suele pasar al jalar ítems de una guía que no tenía un producto asignado — selecciona uno del buscador antes de guardar.`);
      return;
    }
    // Subir adjuntos al backend antes de guardar cotización
    let adjuntos_json = '[]';
    if (adjuntos.length > 0) {
      const formData = new FormData();
      formData.append('serie', form.serie);
      formData.append('numero', form.numero);
      adjuntos.forEach(f => formData.append('adjuntos', f));
      try {
        const res = await axios.post('/api/nota-venta/upload-adjuntos', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (res.data.success) {
          adjuntos_json = JSON.stringify(res.data.files);
        }
      } catch (err) {
        alert('Error al subir adjuntos: ' + (err.response?.data?.error || err.message));
        return;
      }
    }
    // Obtener objeto de condición de pago seleccionado
    const detallesConAlmacen = form.detalles.map(d => {
      // Buscar siempre el objeto de unidad de medida por id o abreviatura
      let unidadObj = null;
      if (d.unidad_medida_id) {
        unidadObj = unidades.find(u => u.id === d.unidad_medida_id);
      } else if (d.unidad_medida) {
        unidadObj = unidades.find(u => u.abreviatura === d.unidad_medida || u.id === d.unidad_medida);
      }
      return {
        ...d,
        almacen_id: d.almacen_id || form.almacen_id,
        unidad_medida_id: unidadObj ? unidadObj.id : null,
        unidad_medida: unidadObj ? unidadObj.abreviatura : ''
      };
    });
    const condicionPagoObj = condicionesPago.find(c => c.id === form.condicion_pago);
    const data = {
      ...form,
      detalles: detallesConAlmacen,
      fecha_validez: form.fecha_validez && !isNaN(new Date(form.fecha_validez)) ? form.fecha_validez : null,
      adjuntos_json,
      condicion_pago_id: condicionPagoObj ? condicionPagoObj.id : null,
      condicion_pago: condicionPagoObj ? condicionPagoObj.descripcion : '',
      total_gravada: form.total_gravada,
      total_exonerada: form.total_exonerada,
      total_inafecta: form.total_inafecta,
      total_gratuita: form.total_gratuita,
      total_exportacion: form.total_exportacion,
      total_otros_cargos: form.total_otros_cargos,
      total_icbper: form.total_icbper,
      total_anticipos: form.total_anticipos,
      total_percepcion: form.total_percepcion,
      total_otros_impuestos: form.total_otros_impuestos,
      usuario_creacion: usuarioLogueado ? (usuarioLogueado.username || usuarioLogueado.email || usuarioLogueado.usuario || '') : '',
      usuario_modificacion: usuarioLogueado ? (usuarioLogueado.username || usuarioLogueado.email || usuarioLogueado.usuario || '') : ''
    };
    // Al crear (no editar), no enviar el número: el "siguiente número" mostrado en
    // el formulario es solo referencial y puede quedar desactualizado (dos notas de
    // venta creadas sin refrescar la pantalla). Dejar que el backend lo asigne de
    // forma atómica evita duplicados.
    if (!form.id) delete data.numero;
    // Log para verificar los datos enviados
    console.log('Datos enviados a backend (nota de venta):', data);
    // Si existe id, actualizar; si no, crear
    try {
      let notaventaId = form.id;
      if (form.id) {
        await axios.put(`/api/nota-venta/${form.id}`, data);
      } else {
        const res = await axios.post('/api/nota-venta', data);
        notaventaId = res.data.id || res.data.insertId;
      }
      // Guardar datos adicionales
      const _userAdic = usuarioLogueado ? (usuarioLogueado.username || usuarioLogueado.email || usuarioLogueado.usuario || '') : '';
      if (notaventaId) {
        const adicSave = [];
        if (ordenCompraAdicional.trim() !== '') adicSave.push(axios.post('/api/datos-adicionales', { comprobante_tipo: 'NOTA_VENTA', comprobante_id: notaventaId, campo: 'orden_compra', valor: ordenCompraAdicional.trim(), usuario_creacion: _userAdic }));
        if (placaAdicional.trim() !== '') adicSave.push(axios.post('/api/datos-adicionales', { comprobante_tipo: 'NOTA_VENTA', comprobante_id: notaventaId, campo: 'placa', valor: placaAdicional.trim(), usuario_creacion: _userAdic }));
        if (adicSave.length) await Promise.all(adicSave);
      }
      fetchNotasVenta();
      handleClose();
    } catch (err) {
      setNvSnackbar({ open: true, msg: err.response?.data?.detalle || err.response?.data?.error || 'Error al guardar la Nota de Venta', severity: 'error' });
      return;
    }
    } finally {
      setGuardando(false);
    }
  };
  // Estado y handlers para datos adicionales
  const [placaAdicional, setPlacaAdicional] = useState('');
  const [ordenCompraAdicional, setOrdenCompraAdicional] = useState('');
  const datosCargadosParaId = useRef(null);

  // Ventana popup de datos adicionales
  const handleCloseDatosAdicionales = () => setOpenDatosAdicionales(false);

  const estadoVencimiento = (fecha_validez) => {
    if (!fecha_validez) return '';
    const hoy = new Date();
    const venc = new Date(fecha_validez);
    if (venc < hoy) return 'VENCIDA';
    if ((venc - hoy) / (1000 * 60 * 60 * 24) <= 3) return 'POR VENCER';
    return 'VIGENTE';
  };

  // Búsqueda asíncrona de clientes en el Autocomplete
  useEffect(() => {
    if (open) {
      fetchClientesAsync(''); // cargar inicial
    }
  }, [open]);

  useEffect(() => {
    if (skipClienteSearch.current) { skipClienteSearch.current = false; return; }
    if (clienteInput !== '') {
      debouncedFetchClientes(clienteInput);
    } else if (open) {
      fetchClientesAsync('');
    }
  }, [clienteInput, open]);

  // Estados para Autocomplete vendedor
  const [vendedorInput, setVendedorInput] = useState('');
  const [loadingVendedores, setLoadingVendedores] = useState(false);

  // Búsqueda asíncrona de vendedores
  const fetchVendedoresAsync = async () => {
    setLoadingVendedores(true);
    if (usuarioLogueado) {
      // Mapear usuario logueado a la estructura esperada por el Autocomplete
      const vendedor = {
        id: usuarioLogueado.id,
        nombres: usuarioLogueado.nombres || usuarioLogueado.nombre || '',
        apellidos: usuarioLogueado.apellidos || '',
        username: usuarioLogueado.username || '',
        // ...otros campos si se requieren
      };
      console.log('Vendedor cargado:', vendedor);
      setVendedores([vendedor]);
      setForm(f => ({ ...f, vendedor_id: vendedor.id }));
    } else {
      setVendedores([]);
    }
    setLoadingVendedores(false);
  };

  const debouncedFetchVendedores = React.useMemo(() => debounce(fetchVendedoresAsync, 300), []);

  // Búsqueda asíncrona de vendedores en el Autocomplete
  useEffect(() => {
    if (open) {
      fetchVendedoresAsync(); // cargar inicial
    }
  }, [open]);

  // Al abrir el formulario, seleccionar por defecto Soles
  useEffect(() => {
    if (open) {
      fetchMonedasAsync('');
      setForm(f => ({ ...f, moneda: 'PEN' }));
    }
  }, [open]);


  // Notas de venta filtradas por búsqueda
  const filteredNotasVenta = notasVenta.filter(nv => {
    const cliente = clientes.find(x => x.id === nv.cliente_id);
    const clienteStr = cliente ? `${cliente.razon_social || ''} ${cliente.numero_documento || ''}` : '';
    return (
      (nv.serie && nv.serie.toLowerCase().includes(search.toLowerCase())) ||
      (nv.numero && nv.numero.toString().includes(search)) ||
      clienteStr.toLowerCase().includes(search.toLowerCase()) ||
      (nv.total && nv.total.toString().includes(search)) ||
      (nv.fecha_emision && nv.fecha_emision.toString().includes(search))
    );
  })
  .sort((a, b) => {
    // Ordenar por fecha de emisión descendente y luego por id descendente
    const fechaA = new Date(a.fecha_emision).getTime() || 0;
    const fechaB = new Date(b.fecha_emision).getTime() || 0;
    if (fechaB !== fechaA) return fechaB - fechaA;
    return Number(b.id || 0) - Number(a.id || 0);
  });

  // Exportar a Excel
  const handleExportExcel = async () => {
    await exportComprobanteWorkbook({
      records: filteredNotasVenta,
      clientes,
      searchText: search,
      usuario: usuarioLogueado?.username || '',
      config: COMPROBANTE_CONFIG.NOTA_VENTA
    });
  };

  // Paginado
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };
  const paginatedNotasVenta = rowsPerPage === -1 ? filteredNotasVenta : filteredNotasVenta.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Lógica para jalar cotizaciones seleccionadas y agregarlas a Nota de Venta
  const jalarCotizacionesSeleccionadas = () => {
    // Buscar cotizaciones seleccionadas en cotizacionesDisponibles
    const cotizaciones = cotizacionesDisponibles.filter(cot => cotizacionesSeleccionadas.includes(cot.id));
    // Extraer todos los detalles de cada cotización
    const cotizacionesYaJaladas = form.detalles.map(d => d.cotizacion_id);
    const nuevosDetalles = cotizaciones.flatMap(cot =>
      cotizacionesYaJaladas.includes(cot.id) ? [] :
      (Array.isArray(cot.detalles) ? cot.detalles : [])
        .map(det => ({
          ...det,
          cotizacion_id: cot.id,
          cotizacion_detalle_id: det.id,
          descripcion_producto: det.descripcion_producto || det.descripcion || '',
          unidad_medida: det.unidad_medida || det.unidad || '',
        }))
    );
    setForm(f => ({
      ...f,
      detalles: [...f.detalles, ...nuevosDetalles]
    }));
    setOpenCotizaciones(false);
    setCotizacionesSeleccionadas([]);
  };

  // Al abrir el modal, limpiar selección y filtrar cotizaciones disponibles
  useEffect(() => {
    if (openCotizaciones) {
        setCotizacionesSeleccionadas([]);
        // Filtrar cotizaciones que ya están en el detalle
        const cotizacionesJaladas = form.detalles.map(d => d.cotizacion_id);
        // Si hay cliente, filtra por su número de documento
        if (form.cliente_id) {
          const cliente = clientes.find(c => c.id === form.cliente_id);
          if (cliente && cliente.numero_documento) {
            setFiltroCotizacion(cliente.numero_documento);
          } else {
            setFiltroCotizacion('');
          }
        } else {
          setFiltroCotizacion('');
        }
        setCotizacionesPage(0);
        fetchCotizaciones(); // Siempre llama para mostrar el listado
    }
    }, [openCotizaciones]);

  // Al cancelar, limpiar selección
  const handleCancelarCotizaciones = () => {
    setOpenCotizaciones(false);
    setCotizacionesSeleccionadas([]);
  };

  // Almacenes disponibles según la sucursal seleccionada (igual que en Guía de Remisión):
  // se incluyen los de la sucursal elegida y los que no tienen sucursal asignada (compartidos)
  const almacenesDisponibles = almacenes.filter(a => {
    const activo = Number(a.estado ?? 1) === 1;
    if (!activo) return false;
    if (!form.sucursal_id) return true;
    if (a.sucursal_id == null) return true;
    return Number(a.sucursal_id) === Number(form.sucursal_id);
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Notas de Venta</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar por serie, número o cliente..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            size="small"
            sx={{ flex: 1, minWidth: 220 }}
          />
          <Button variant="contained" color="success" startIcon={<GridOn />} onClick={handleExportExcel} sx={{ minWidth: 150, display: { xs: 'none', sm: 'flex' } }}>
            Exportar Excel
          </Button>
          <Button variant="contained" color="primary" startIcon={<Add />} onClick={handleOpen} sx={{ minWidth: 120 }}>
            {isMobile ? 'Nueva' : 'Nueva Nota de Venta'}
          </Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            sx={{ width: 100, display: { xs: 'none', sm: 'block' } }}
            inputProps={{ min: 1 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Serie</TableCell>
                <TableCell align="center">Número</TableCell>
                <TableCell align="center">Cliente</TableCell>
                <TableCell align="center">Fecha Emisión</TableCell>
                <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Vence</TableCell>
                <TableCell align="center">Estado</TableCell>
                <TableCell align="center">Total</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedNotasVenta.map(nv => (
                <TableRow key={nv.id}>
                  <TableCell align="center">{nv.serie}</TableCell>
                  <TableCell align="center">{nv.numero}</TableCell>
                  <TableCell align="center">{
                    (() => {
                      const cliente = clientes.find(x => x.id === nv.cliente_id);
                      if (cliente) {
                        const nombreCliente = cliente.razon_social || `${cliente.nombres || ''} ${cliente.apellidos || ''}`.trim();
                        return `${nombreCliente}${cliente.numero_documento ? ` (${cliente.numero_documento})` : ''}`;
                      } else if (nv.cliente_id) {
                        return `ID: ${nv.cliente_id}`;
                      } else {
                        return 'Sin cliente';
                      }
                    })()
                  }</TableCell>
                  <TableCell align="center">{nv.fecha_emision?.substring(0, 10)}</TableCell>
                  <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{nv.fecha_validez?.substring(0, 10)}</TableCell>
                  <TableCell align="center">
                    {(() => {
                        // Validar si está anulada por estado o estado_registro
                        if (nv.estado === 'ANULADA' || nv.estado_registro === 0) {
                            return (
                            <Tooltip title="Anulada">
                                <Chip icon={<Cancel color="error" />} label="Anulada" color="error" />
                            </Tooltip>
                            );
                        }
                        if (nv.estado === 'FACTURADA') {
                            return (
                            <Tooltip title="Convertida a comprobante electrónico">
                                <Chip icon={<SwapHoriz />} label="Facturada" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32', fontWeight: 'bold', border: '1px solid #81c784' }} />
                            </Tooltip>
                            );
                        }
                        const estado = estadoVencimiento(nv.fecha_validez);
                        if (estado === 'VENCIDA') {
                            return (
                            <Tooltip title="Vencida">
                                <Chip icon={<Cancel color="error" />} label="Vencida" color="error" />
                            </Tooltip>
                            );
                        } else if (estado === 'POR VENCER') {
                            return (
                            <Tooltip title="Por vencer">
                                <Chip icon={<Warning color="warning" />} label="Por vencer" color="warning" />
                            </Tooltip>
                            );
                        } else {
                            return (
                            <Tooltip title="Vigente">
                                <Chip icon={<CheckCircle color="success" />} label="Vigente" color="success" />
                            </Tooltip>
                            );
                        }
                    })()}
                  </TableCell>
                  <TableCell align="center">{nv.total}</TableCell>
                  <TableCell align="center">
                    {/* Botones de acciones con colores y nuevas funciones */}
                  <Tooltip title="Anular">
                    <IconButton color="error" onClick={async () => {
                        if (window.confirm('¿Seguro que deseas anular esta nota de venta?')) {
                            try {
                            await axios.put(`/api/nota-venta/${nv.id}/anular`);
                            fetchNotasVenta();
                            } catch (err) {
                            alert(err.response?.data?.error || 'Error al anular la nota de venta.');
                            }
                        }
                    }}
                    disabled={nv.estado === 'ANULADA' || nv.estado_registro === 0}
                    >
                    <Cancel />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Ver">
                    <IconButton color="success" onClick={async () => {
                      try {
                        const res = await axios.get(`/api/nota-venta/${nv.id}`);
                        const nota = res.data;
                        // Parsear detalles y adjuntos si vienen como string
                        let detalles = Array.isArray(nota.detalles) ? nota.detalles : (typeof nota.detalles === 'string' && nota.detalles ? JSON.parse(nota.detalles) : []);
                        let adjuntos_json = Array.isArray(nota.adjuntos_json) ? nota.adjuntos_json : (typeof nota.adjuntos_json === 'string' && nota.adjuntos_json ? JSON.parse(nota.adjuntos_json) : []);
                        let estadoVisual = estadoVencimiento(nota.fecha_validez);
                        if (!nota.fecha_validez) {
                          estadoVisual = 'VIGENTE';
                        }
                        setVerNotaVenta({ ...nota, detalles, adjuntos_json, estadoVisual });
                      } catch (err) {
                        alert('Error al obtener detalles de la nota de venta.');
                      }
                    }}>
                      <CheckCircle />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="PDF">
                    <IconButton color="secondary" onClick={() => abrirDialogoPdfNv(nv)}>
                      <CloudUpload />
                    </IconButton>
                  </Tooltip>
                  {nv.estado !== 'ANULADA' && nv.estado !== 'FACTURADA' && nv.estado_registro !== 0 && (
                    <Tooltip title="Emitir comprobante electrónico">
                      <IconButton sx={{ color: '#1a237e' }} onClick={() => {
                        setNvConvertirDoc(nv);
                        const docCliente = clientes.find(x => x.id === nv.cliente_id)?.numero_documento || nv.numero_documento || '';
                        const tipoInicial = /^\d{11}$/.test(docCliente) ? 'FACTURA' : 'BOLETA';
                        setNvConvertirTipo(tipoInicial);
                        fetchNvSeriesConversion(tipoInicial);
                        setNvConvertirDialog(true);
                      }}>
                        <SwapHoriz />
                      </IconButton>
                    </Tooltip>
                  )}
                        {/* Modal para ver nota de venta */}
                        {verNotaVenta && (
                          <Dialog open={true} onClose={() => setVerNotaVenta(null)} maxWidth="md" fullWidth>
                            <DialogTitle>Detalle de Nota de Venta</DialogTitle>
                            <DialogContent>
                              <Typography variant="h6">Cliente: {clientes.find(x => x.id === verNotaVenta.cliente_id)?.razon_social || ''}</Typography>
                              <Typography>Serie: {verNotaVenta.serie} Número: {verNotaVenta.numero}</Typography>
                              <Typography>Fecha Emisión: {verNotaVenta.fecha_emision?.substring(0, 10) || ''}</Typography>
                              <Typography>Moneda: {verNotaVenta.moneda}</Typography>
                              <Typography>Condición Pago: {verNotaVenta.condicion_pago || ''}</Typography>
                              <Typography>Estado: {
                                verNotaVenta.estado === 'PENDIENTE'
                                  ? (verNotaVenta.estadoVisual || verNotaVenta.estado)
                                  : verNotaVenta.estado
                              }</Typography>
                              <Typography>Observaciones: {verNotaVenta.observaciones || ''}</Typography>
                              <TableContainer component={Paper} sx={{ mt: 2 }}>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Código</TableCell>
                                      <TableCell>Producto</TableCell>
                                      <TableCell>Almacén</TableCell>
                                      <TableCell>Cantidad</TableCell>
                                      <TableCell>U.Medida</TableCell>
                                      <TableCell>Precio</TableCell>
                                      <TableCell>Subtotal</TableCell>
                                      <TableCell>IGV</TableCell>
                                      <TableCell>Total</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {(Array.isArray(verNotaVenta.detalles) ? verNotaVenta.detalles : (typeof verNotaVenta.detalles === 'string' && verNotaVenta.detalles && verNotaVenta.detalles.trim().startsWith('[') ? JSON.parse(verNotaVenta.detalles) : [])).map((d, idx) => (
                                      <TableRow key={idx}>
                                        <TableCell>{d.codigo_producto || productos.find(p => p.id === d.producto_id)?.codigo || ''}</TableCell>
                                        <TableCell>{d.descripcion_producto || productos.find(p => p.id === d.producto_id)?.nombre || ''}</TableCell>
                                        <TableCell>{almacenes.find(a => a.id === d.almacen_id)?.nombre || ''}</TableCell>
                                        <TableCell>{d.cantidad}</TableCell>
                                        <TableCell>{d.unidad_medida}</TableCell>
                                        <TableCell>{d.precio_unitario}</TableCell>
                                        <TableCell>{d.subtotal}</TableCell>
                                        <TableCell>{d.igv_monto}</TableCell>
                                        <TableCell>{d.total}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              {/* Adjuntos */}
                              {verNotaVenta.adjuntos_json && typeof verNotaVenta.adjuntos_json === 'string' && verNotaVenta.adjuntos_json.trim().startsWith('[') && JSON.parse(verNotaVenta.adjuntos_json).length > 0 && (
                                <Box mt={2}>
                                  <Typography variant="h6">Documentos Adjuntos</Typography>
                                  {JSON.parse(verNotaVenta.adjuntos_json).map((nombre, idx) => (
                                    <Button key={idx} variant="outlined" color="info" startIcon={<AttachFile />} onClick={() => {
                                      // Descarga directa desde la ruta correcta
                                      const link = document.createElement('a');
                                      link.href = `/api/nota-venta/adjunto/${verNotaVenta.serie}/${verNotaVenta.numero}/${nombre}?token=${localStorage.getItem('token') || ''}`;
                                      link.target = '_blank';
                                      link.download = nombre;
                                      document.body.appendChild(link);
                                      link.click();
                                      document.body.removeChild(link);
                                    }} sx={{ mr: 1 }}>
                                      {nombre}
                                    </Button>
                                  ))}
                                </Box>
                              )}
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={() => setVerNotaVenta(null)} startIcon={<Cancel />}>Cerrar</Button>
                            </DialogActions>
                          </Dialog>
                        )}
                  {/* Botón para descargar/ver adjuntos */}
                  {nv.adjuntos_json && JSON.parse(nv.adjuntos_json).length > 0 && (
                    <Tooltip title="Descargar adjuntos">
                      <IconButton color="info" onClick={e => {
                        e.stopPropagation();
                        const tk = localStorage.getItem('token') || '';
                        JSON.parse(nv.adjuntos_json).forEach((nombre, i) => {
                          setTimeout(() => {
                            const a = document.createElement('a');
                            a.href = `/api/nota-venta/adjunto/${nv.serie}/${nv.numero}/${nombre}?token=${tk}`;
                            a.download = nombre;
                            document.body.appendChild(a); a.click(); document.body.removeChild(a);
                          }, i * 500);
                        });
                      }}>
                        <AttachFile />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginacionControl page={page} rowsPerPage={rowsPerPage} count={filteredNotasVenta.length} onPageChange={handleChangePage} />
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="lg" fullWidth fullScreen={isMobile}>
        <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: { xs: 17, sm: 22 }, letterSpacing: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Receipt sx={{ mr: 1, mb: -0.5 }} /> {modoEdicion ? 'Editar Nota de Venta' : 'Nueva Nota de Venta'}
          </Box>
          {isMobile && (<IconButton size="small" onClick={handleClose} sx={{ color: '#fff' }}><Close /></IconButton>)}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 2 }} justifyContent={'center'}>
            <Grid item xs={4} sx={{ width: { xs: '100%', sm: '30em' }, minWidth: { xs: 0, sm: '30em' } }}>
              <Autocomplete
                options={sucursales}
                getOptionLabel={option => option.nombre ? `${option.nombre}` : ''}
                value={sucursales.find(s => s.id === form.sucursal_id) || null}
                inputValue={sucursalInput}
                onInputChange={(e, value) => setSucursalInput(value)}
                onChange={(e, value) => { if (value) setForm(f => ({ ...f, sucursal_id: value.id })); }}
                loading={loadingSucursales}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Sucursal" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField type="date" label="Emisión" name="fecha_emision" value={form.fecha_emision} onChange={handleFechaEmisionChange} fullWidth InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={2}>
              <TextField type="date" label="Vence" name="fecha_validez" value={form.fecha_validez} onChange={handleFormChange} fullWidth InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={2} sx={{ width: '8em', minWidth: '8em', flexBasis: '8em !important', maxWidth: 'none !important' }}>
              <Autocomplete
                options={series}
                getOptionLabel={option => option.serie ? `${option.serie}` : ''}
                value={series.find(s => s.serie === form.serie) || null}
                inputValue={serieInput}
                onInputChange={(e, value) => setSerieInput(value)}
                onChange={(e, value) => {
                  setForm(f => ({ ...f, serie: value ? value.serie : '' }));
                  if (!modoEdicion) {
                    setForm(f => ({ ...f, numero: value ? value.correlativo_actual : '' }));
                  }
                }}
                loading={loadingSeries}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Serie" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2} sx={{ width: '8em', minWidth: '8em', flexBasis: '8em !important', maxWidth: 'none !important' }}>
              <TextField label="Número" name="numero" value={form.numero} fullWidth required disabled />
            </Grid>
            <Grid item xs={4} sx={{ width: { xs: '100%', sm: '30em' }, minWidth: { xs: 0, sm: '30em' } }}>
              <Autocomplete
                options={clientes}
                getOptionLabel={option => {
                  const nombreCliente = option.razon_social || `${option.nombres || ''} ${option.apellidos || ''}`.trim();
                  return nombreCliente && option.numero_documento ? `${nombreCliente} (${option.numero_documento})` : nombreCliente;
                }}
                value={clientes.find(c => c.id === form.cliente_id) || null}
                inputValue={clienteInput}
                onInputChange={(e, value) => setClienteInput(value)}
                noOptionsText={clienteInput.length >= 2 ? (<Button size="small" onMouseDown={(e) => e.preventDefault()} onClick={() => setOpenNuevoCliente(true)}>+ Registrar "{clienteInput}" como nuevo cliente</Button>) : 'Escribe para buscar'}
                onChange={(e, value) => setForm(prev => ({ ...prev, cliente_id: value ? value.id : '' }))}
                loading={loadingClientes}
                renderInput={params => (
                  <TextField {...params} label="Cliente" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2}  sx={{ width: '13em', minWidth: '13em' }}>
              <Autocomplete
                options={monedas}
                getOptionLabel={option => option.descripcion && option.codigo ? `${option.descripcion} (${option.codigo})` : option.descripcion || ''}
                value={monedas.find(m => m.codigo === form.moneda) || null}
                inputValue={monedaInput}
                onInputChange={(e, value) => setMonedaInput(value)}
                onChange={async (e, value) => {
                  const nuevaMoneda = value ? value.codigo : '';
                  setForm(f => ({ ...f, moneda: nuevaMoneda }));
                  if (nuevaMoneda === 'USD') {
                    const fecha = form.fecha_emision;
                    try {
                      // 1. Buscar en la BD
                      const resBD = await axios.get('/api/tipo-cambio');
                      const tc = resBD.data.find(x => x.fecha && x.fecha.substring(0,10) === fecha);
                      if (tc && tc.venta) {
                        setForm(f => ({ ...f, tipo_cambio: tc.venta }));
                        return;
                      }
                    } catch {}
                    try {
                      // 2. Si no existe en BD, buscar en API
                      const res = await axios.get(`/api/tipo-cambio/sunat?fecha=${fecha}`);
                      if (res.data && res.data.venta) {
                        setForm(f => ({ ...f, tipo_cambio: res.data.venta }));
                        return;
                      }
                    } catch {}
                    // 3. Si falla todo, poner 1
                    setForm(f => ({ ...f, tipo_cambio: 1 }));
                  } else {
                    setForm(f => ({ ...f, tipo_cambio: 1 }));
                  }
                }}
                loading={loadingMonedas}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Moneda" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2} sx={{ width: '8em', minWidth: '8em' }}>
              <TextField label="Tipo Cambio" name="tipo_cambio" value={form.tipo_cambio} onChange={handleFormChange} fullWidth />
            </Grid>
            <Grid item xs={2} sx={{ width: { xs: '100%', sm: '15.6em' }, minWidth: { xs: 0, sm: '15.6em' } }}>
              <Autocomplete
                options={vendedores}
                getOptionLabel={option => option.nombres && option.apellidos && option.username ? `${option.nombres} ${option.apellidos} (${option.username})` : option.nombres || ''}
                value={vendedores.find(v => v.id === form.vendedor_id) || null}
                inputValue={vendedores.find(v => v.id === form.vendedor_id) ? `${vendedores.find(v => v.id === form.vendedor_id).nombres} ${vendedores.find(v => v.id === form.vendedor_id).apellidos} (${vendedores.find(v => v.id === form.vendedor_id).username})` : ''}
                disabled
                renderInput={params => (
                  <TextField {...params} label="Vendedor" fullWidth required disabled />
                )}
              />
            </Grid>
            <Grid item xs={4} sx={{ width: { xs: '100%', sm: '18em' }, minWidth: { xs: 0, sm: '18em' } }}>
              <Autocomplete
                options={condicionesPago}
                getOptionLabel={option => option?.descripcion || ''}
                value={condicionesPago.find(c => c.id === form.condicion_pago) || null}
                onChange={(e, value) => setForm(f => ({ ...f, condicion_pago: value ? value.id : '' }))}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                loading={loadingCondicionesPago}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Condición Pago" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={8}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={8} sx={{ minWidth: { xs: 0, sm: '27em' } }}>
                  <TextField label="Observaciones" name="observaciones" value={form.observaciones} onChange={handleFormChange} fullWidth sx={{ minWidth: { xs: 0, sm: '27em' } }} />
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<AddCircleIcon />}
                    fullWidth
                    sx={{ backgroundColor: '#f3e5f5', color: '#7b1fa2', fontWeight: 'bold' }}
                    onClick={handleOpenDatosAdicionales} // función para abrir el diálogo de datos adicionales
                  >
                    Datos adicionales
                  </Button>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    color="info"
                    component="label"
                    startIcon={<AttachFile />}
                    fullWidth
                    sx={{ backgroundColor: '#e3f2fd', color: '#1976d2', fontWeight: 'bold' }}
                  >
                    Adjuntar
                    <input type="file" hidden multiple onChange={handleAdjunto} />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h6" sx={{ color: '#000000', fontWeight: 'bold' }}>Detalle de productos</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setOpenCotizaciones(true)}
                        sx={{ minWidth: 180, fontWeight: 'bold' }}
                    >
                        + Adicionar Cotización
                    </Button>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={copiarNombreADesc}
                        onChange={e => setCopiarNombreADesc(e.target.checked)}
                        color="secondary"
                        size="small"
                      />
                    }
                    label={<Typography variant="caption">Copiar nombre → descripción</Typography>}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={preciosIncluyenIgv}
                        onChange={e => setPreciosIncluyenIgv(e.target.checked)}
                        color="primary"
                        size="small"
                      />
                    }
                    label={<Typography variant="caption">Precios incluyen IGV</Typography>}
                  />
                </Box>
              </Box>
              <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                <Table size="small" sx={{ tableLayout: 'fixed', minWidth: 680 }}>
                  <colgroup>
                    <col style={{ width: colW.codigo }} />
                    <col style={{ width: colW.producto }} />
                    <col style={{ width: colW.cant }} />
                    <col style={{ width: colW.umedida }} />
                    <col style={{ width: colW.precio }} />
                    <col style={{ width: colW.dscto }} />
                    <col style={{ width: colW.total }} />
                    <col style={{ width: colW.almacen }} />
                    <col style={{ width: colW.acciones }} />
                  </colgroup>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#2e8ae6' }}>
                      {[
                        { key: 'codigo',   label: 'Código' },
                        { key: 'producto', label: 'Producto' },
                        { key: 'cant',     label: 'Cant.' },
                        { key: 'umedida',  label: 'U.Med' },
                        { key: 'precio',   label: 'Precio' },
                        { key: 'dscto',    label: 'Dscto' },
                        { key: 'total',    label: 'Total' },
                        { key: 'almacen',  label: 'Almacén' },
                        { key: 'acciones', label: 'Acciones' },
                      ].map(col => (
                        <TableCell key={col.key} align="center" sx={{
                          position: 'relative', color: '#fff', fontWeight: 'bold',
                          overflow: 'hidden', whiteSpace: 'nowrap', userSelect: 'none',
                          px: 1,
                        }}>
                          {col.label}
                          {col.key !== 'acciones' && (
                            <ResizeHandle onMouseDown={e => startResize(col.key, e)} />
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {form.detalles.map((d, idx) => (
                      <TableRow key={idx} sx={{ backgroundColor: idx % 2 === 0 ? '#f5f5f5' : '#fff' }}>
                        <TableCell align="center" sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', px: 1 }}>
                          {d.codigo_producto || ''}
                        </TableCell>
                        <TableCell sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', px: 1 }}>
                          <Tooltip title={d.descripcion_producto || ''}>
                            <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {d.descripcion_producto || productos.find(p => p.id === d.producto_id)?.nombre || ''}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center" sx={{ px: 1 }}>{d.cantidad}</TableCell>
                        <TableCell align="center" sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', px: 1 }}>
                          {unidades.find(u => u.id === d.unidad_medida)?.abreviatura || d.unidad_medida}
                        </TableCell>
                        <TableCell align="right" sx={{ px: 1 }}>{d.precio_unitario}</TableCell>
                        <TableCell align="center" sx={{ px: 1 }}>{d.descuento_monto || d.descuento_porcentaje || ''}</TableCell>
                        <TableCell align="right" sx={{ px: 1, fontWeight: 'bold' }}>{d.total}</TableCell>
                        <TableCell sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', px: 1 }}>
                          {almacenes.find(a => a.id === d.almacen_id)?.nombre || ''}
                        </TableCell>
                        <TableCell align="center" sx={{ px: 0.5 }}>
                          <Tooltip title="Editar"><IconButton size="small" color="primary" onClick={() => editarDetalle(idx)}><Edit fontSize="small" /></IconButton></Tooltip>
                          <Tooltip title="Eliminar"><IconButton size="small" color="error" onClick={() => eliminarDetalle(idx)}><Delete fontSize="small" /></IconButton></Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid container spacing={1} alignItems="center" justifyContent={'center'}>
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '20em' }, minWidth: { xs: 0, sm: '20em' } }}>
                  <Autocomplete
                    options={productos}
                    getOptionLabel={option => option?.nombre || ''}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.codigo && (
                          <Box component="span" sx={{ color: 'text.secondary', fontSize: '0.78em', mr: 1, minWidth: '4.5em', flexShrink: 0 }}>
                            {option.codigo}
                          </Box>
                        )}
                        {option.nombre}
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      const v = inputValue.toLowerCase();
                      const filtered = options.filter(o =>
                        (o.nombre || '').toLowerCase().includes(v) ||
                        (o.codigo || '').toLowerCase().includes(v)
                      );
                      const selId = detalle.producto_id;
                      if (selId && !filtered.some(o => o.id === selId)) {
                        const sel = options.find(o => o.id === selId);
                        if (sel) return [sel, ...filtered];
                      }
                      return filtered;
                    }}
                    value={productos.find(p => p.id === detalle.producto_id) || null}
                    inputValue={productoInput}
                    onInputChange={(e, value, reason) => {
                      if (reason === 'input') {
                        setProductoInput(value);
                        debouncedFetchProductos(value);
                      } else if (reason === 'clear') {
                        setProductoInput('');
                        debouncedFetchProductos('');
                      }
                    }}
                    noOptionsText={productoInput.length >= 2 ? (<Button size="small" onMouseDown={(e) => e.preventDefault()} onClick={() => setOpenNuevoProducto(true)}>+ Registrar "{productoInput}" como nuevo producto</Button>) : 'Escribe para buscar'}
                    onChange={(e, value) => {
                      handleDetalleChange({ target: { name: 'producto_id', value: value ? value.id : '' } });
                      setProductoInput(value ? (value.nombre || '') : '');
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={params => (
                      <TextField {...params} label="Producto" fullWidth error={detalleError.producto} />
                    )}
                  />
                </Grid>
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '21em' }, minWidth: { xs: 0, sm: '21em' } }}>
                  <TextField
                    label="Descripción de producto"
                    name="descripcion_producto"
                    value={detalle.descripcion_producto}
                    onChange={handleDetalleChange}
                    fullWidth
                    onKeyDown={e => { if (e.key === 'F1') { e.preventDefault(); setOpenBuscadorProducto(true); } }}
                    InputProps={{
                      endAdornment: (
                        <Tooltip title="Buscar producto (F1)">
                          <IconButton size="small" onClick={() => setOpenBuscadorProducto(true)} edge="end">
                            <SearchIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Cant." name="cantidad" value={detalle.cantidad} onChange={handleDetalleChange} fullWidth error={detalleError.cantidad} />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Precio" name="precio_unitario" value={detalle.precio_unitario} onChange={handleDetalleChange} fullWidth />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Desc. S/" name="descuento_monto" value={detalle.descuento_monto} onChange={handleDetalleChange} fullWidth />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Desc. %" name="descuento_porcentaje" value={detalle.descuento_porcentaje} onChange={handleDetalleChange} fullWidth />
                </Grid>
                {isMobile && <div style={{ flexBasis: '100%', width: '100%', height: 0 }} />}
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '24em' }, minWidth: { xs: 0, sm: '24em' }, mt: { xs: 0, sm: 1 } }}>
                  <Autocomplete
                    options={Array.isArray(tiposIGV) ? tiposIGV : []}
                    getOptionLabel={option => option?.descripcion || ''}
                    value={Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === detalle.tipo_igv) || null : null}
                    onChange={(e, value) => {
                      handleDetalleChange({ target: { name: 'tipo_igv', value: value ? value.codigo : '' } });
                    }}
                    isOptionEqualToValue={(option, value) => option.codigo === value.codigo}
                    loading={loadingTiposIGV}
                    disableClearable
                    renderInput={params => (
                      <TextField {...params} label="Tipo IGV" fullWidth />
                    )}
                  />
                </Grid>
                {isMobile && <div style={{ flexBasis: '100%', width: '100%', height: 0 }} />}
                <Grid item xs={2} sx={{ width: { xs: '100%', sm: '16em' }, minWidth: { xs: 0, sm: '16em' }, mt: { xs: 0, sm: 1 } }}>
                  <Autocomplete
                    options={unidades}
                    getOptionLabel={option => option?.nombre ? `${option.nombre} (${option.abreviatura})` : ''}
                    value={unidades.find(u => u.id === detalle.unidad_medida) || null}
                    onChange={(e, value) => {
                      handleDetalleChange({ target: { name: 'unidad_medida', value: value ? value.id : '' } });
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    renderInput={params => (
                      <TextField {...params} label="U.Medida" fullWidth />
                    )}
                  />
                </Grid>
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '20em' }, minWidth: { xs: 0, sm: '20em' }, mt: { xs: 0, sm: 0.5 } }}>
                  <Autocomplete
                    options={almacenesDisponibles}
                    getOptionLabel={option => option.nombre || ''}
                    value={almacenesDisponibles.find(a => a.id === detalle.almacen_id) || null}
                    onChange={(e, value) => {
                      setDetalle(d => ({ ...d, almacen_id: value ? value.id : '' }));
                      setDetalleError(err => ({ ...err, almacen: false }));
                      setDetalleErrorMsg('');
                    }}
                    inputValue={almacenInput}
                    onInputChange={(e, value) => setAlmacenInput(value)}
                    loading={loadingAlmacenes}
                    renderInput={params => (
                      <TextField {...params} label="Almacén" size="small" fullWidth margin="dense" error={detalleError.almacen} required
                        onKeyDown={e => { if (e.key === 'F1') { e.preventDefault(); if (detalle.producto_id) setOpenStockAlmacen(true); } }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disableClearable
                  />
                </Grid>
                <Grid item xs={2} sx={{ mt: 1 }}>
                  <Button
                    variant="contained"
                    color="success"
                    startIcon={editingDetalle === null ? <Add /> : <CheckCircle />}
                    onClick={editingDetalle === null ? agregarDetalle : actualizarDetalle}
                    sx={{ backgroundColor: '#e8f5e9', color: '#388e3c', fontWeight: 'bold' }}
                  >
                    {editingDetalle === null ? 'Agregar' : 'Actualizar'}
                  </Button>
                </Grid>
                {stockDisponible !== null && (() => {
                  const cantEnGrid = form.detalles
                    .filter(d => d.producto_id === detalle.producto_id && d.almacen_id === detalle.almacen_id)
                    .reduce((s, d) => s + Number(d.cantidad || 0), 0);
                  const excede = Number(detalle.cantidad) > 0 && (cantEnGrid + Number(detalle.cantidad)) > Number(stockDisponible);
                  return (
                    <Grid item xs={12} sx={{ textAlign: 'center', mt: 0.5 }}>
                      <Chip
                        label={`Stock disponible: ${parseFloat(stockDisponible).toFixed(2)}`}
                        color={excede ? 'error' : 'success'}
                        size="small"
                        variant="outlined"
                      />
                      {excede && (
                        <Typography variant="caption" display="block" color="error" sx={{ mt: 0.5 }}>
                          {cantEnGrid > 0
                            ? `Stock insuficiente. Ya tiene ${cantEnGrid.toFixed(2)} de este producto en la grilla. Disponible: ${parseFloat(stockDisponible).toFixed(2)} unidades.`
                            : `Stock insuficiente. Disponible en almacén: ${parseFloat(stockDisponible).toFixed(2)} unidades.`}
                        </Typography>
                      )}
                    </Grid>
                  );
                })()}
                {detalleErrorMsg && (
                  <Grid item xs={12}>
                    <Typography color="error" sx={{ mb: 1 }}>{detalleErrorMsg}</Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            {isMobile ? (
              <Grid item xs={12} sx={{ mt: 1 }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <TextField label="Subtotal" value={Number(form.subtotal).toFixed(2)} InputProps={{ readOnly: true }} size="small" slotProps={{ input: { sx: { bgcolor: '#e3f2fd', fontWeight: 'bold' } }, htmlInput: { style: { textAlign: 'center' } } }} />
                  <TextField label="IGV" value={Number(form.total_igv).toFixed(2)} InputProps={{ readOnly: true }} size="small" slotProps={{ input: { sx: { bgcolor: '#fff9c4', fontWeight: 'bold' } }, htmlInput: { style: { textAlign: 'center' } } }} />
                  <TextField label="Total" value={Number(form.total).toFixed(2)} InputProps={{ readOnly: true }} size="small" slotProps={{ input: { sx: { bgcolor: '#e8f5e9', fontWeight: 'bold' } }, htmlInput: { style: { textAlign: 'center' } } }} />
                </Box>
              </Grid>
            ) : (
              <>
                <Grid item xs={4} sx={{ minWidth: '18em', mt: 2 }}>
                  <TextField
                    label="Subtotal"
                    value={Number(form.subtotal).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: {
                          textAlign: 'center',
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold'
                        },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
                <Grid item xs={4} sx={{ minWidth: '18em', mt: 2 }}>
                  <TextField
                    label="IGV"
                    value={Number(form.total_igv).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: {
                          textAlign: 'center',
                          backgroundColor: '#fff9c4',
                          fontWeight: 'bold'
                        },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
                <Grid item xs={4} sx={{ minWidth: '18em', mt: 2 }}>
                  <TextField
                    label="Total"
                    value={Number(form.total).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: {
                          textAlign: 'center',
                          backgroundColor: '#e8f5e9',
                          fontWeight: 'bold'
                        },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch checked={mostrarResumenIGV} onChange={() => setMostrarResumenIGV(v => !v)} color="primary" />}
                label={mostrarResumenIGV ? "Resumen por tipo de IGV: Activo" : "Resumen por tipo de IGV: Oculto"}
              />
            </Grid>
            {mostrarResumenIGV && (
              <Grid item xs={12} sx={{ width: '100%' }}>
                <Typography variant="h6" gutterBottom sx={{ width: '100%', textAlign: 'center' }}>Resumen por tipo de IGV</Typography>
                <TableContainer component={Paper} sx={{ width: '100%' }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Tipo IGV</TableCell>
                        <TableCell align="right">Base Imponible</TableCell>
                        <TableCell align="right">IGV</TableCell>
                        <TableCell align="right">Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(() => {
                        // Agrupar detalles por código IGV y mostrar descripción
                        const codigosGratuitos = ['21','31','32','33','34','35'];
                        const resumen = {};
                        form.detalles.forEach(d => {
                          const tipoIGV = Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === d.tipo_igv) : undefined;
                          const codigo = tipoIGV?.codigo || d.tipo_igv || 'Otro';
                          const descripcion = tipoIGV?.descripcion || d.tipo_igv || 'Otro';
                          if (!resumen[codigo]) resumen[codigo] = { descripcion, base: 0, igv: 0, total: 0, esGratuito: codigosGratuitos.includes(codigo) };
                          if (codigosGratuitos.includes(codigo)) {
                            resumen[codigo].base += parseFloat(d.subtotal) || 0;
                            resumen[codigo].igv += 0;
                            resumen[codigo].total += 0;
                          } else {
                            resumen[codigo].base += parseFloat(d.subtotal) || 0;
                            resumen[codigo].igv += parseFloat(d.igv_monto) || 0;
                            resumen[codigo].total += parseFloat(d.total) || 0;
                          }
                        });
                        // Mostrar solo los tipos con base > 0
                        const filas = Object.entries(resumen).filter(([_, v]) => v.base > 0);
                        // Calcular totales generales, excluyendo gratuitos del total general
                        const totalBase = filas.reduce((a, [_, v]) => v.esGratuito ? a : a + v.base, 0);
                        const totalIGV = filas.reduce((a, [_, v]) => v.esGratuito ? a : a + v.igv, 0);
                        const totalTotal = filas.reduce((a, [_, v]) => v.esGratuito ? a : a + v.total, 0);
                        return <>
                          {filas.map(([codigo, v]) => (
                            <TableRow key={codigo}>
                              <TableCell>{v.descripcion} ({codigo})</TableCell>
                              <TableCell align="right">S/ {v.base.toFixed(2)}</TableCell>
                              <TableCell align="right">S/ {v.igv.toFixed(2)}</TableCell>
                              <TableCell align="right">S/ {v.total.toFixed(2)}</TableCell>
                            </TableRow>
                          ))}
                          <TableRow sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                            <TableCell><b>Totales</b></TableCell>
                            <TableCell align="right"><b>S/ {totalBase.toFixed(2)}</b></TableCell>
                            <TableCell align="right"><b>S/ {totalIGV.toFixed(2)}</b></TableCell>
                            <TableCell align="right"><b>S/ {totalTotal.toFixed(2)}</b></TableCell>
                          </TableRow>
                        </>;
                      })()}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 1 }, gap: 1 }}>
          {!isMobile && <Button onClick={handleClose} startIcon={<Cancel />} color="error" variant="contained">Cancelar</Button>}
          <Button onClick={handleSubmit} disabled={guardando} variant="contained" color="primary" startIcon={<CloudUpload />} fullWidth={isMobile}>{guardando ? 'Guardando...' : 'Guardar Nota de Venta'}</Button>
        </DialogActions>
      </Dialog>
    {/* Popup de datos adicionales */}
    <Dialog open={openDatosAdicionales} onClose={handleCloseDatosAdicionales} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold' }}>Datos adicionales</DialogTitle>
      <DialogContent sx={{ pt: 1, pb: 0 }}>
        <TextField
          label="Orden de Compra"
          value={ordenCompraAdicional}
          onChange={e => setOrdenCompraAdicional(e.target.value)}
          fullWidth
          margin="dense"
          placeholder="Nro. orden de compra del cliente..."
        />
        <TextField
          label="Placa"
          value={placaAdicional}
          onChange={e => setPlacaAdicional(e.target.value)}
          fullWidth
          margin="dense"
          placeholder="Ingrese la placa..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDatosAdicionales} color="error" variant="contained" startIcon={<Cancel />}>Cerrar</Button>
      </DialogActions>
    </Dialog>
    {/* Popup de cotizaciones */}
    <Dialog open={openCotizaciones} onClose={() => setOpenCotizaciones(false)} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: 20 }}>
            Jalar Cotizaciones
        </DialogTitle>
        <DialogContent>
            <Tabs value={refTab} onChange={(_e, v) => { setRefTab(v); setCotizacionesPage(0); setCotizacionesSeleccionadas([]); }} sx={{ mt: 1, minHeight: 36 }}>
                <Tab label="Disponibles" sx={{ minHeight: 36 }} />
                <Tab label="Ya referenciado" sx={{ minHeight: 36 }} />
            </Tabs>
            {refTab === 1 && (
              <Alert severity="info" sx={{ mt: 1 }}>
                Estas cotizaciones (o alguna de sus líneas) ya fueron jaladas antes. Puedes volver a jalarlas si quieres armar una NV con lo que falte — revisa primero con el botón <InfoIcon sx={{ fontSize: 16, verticalAlign: 'middle' }} /> qué las referenció.
              </Alert>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt:2 }}>
                <TextField
                    placeholder="Buscar por serie, número, RUC, razón social, fecha, estado..."
                    value={filtroCotizacionInput}
                    onChange={e => setFiltroCotizacionInput(e.target.value)}
                    size="small"
                    sx={{ flex: 1, minWidth: 220 }}
                />
                <TextField
                    size="small"
                    label="Mostrar"
                    type="number"
                    value={cotizacionesRowsPerPage}
                    onChange={e => setCotizacionesRowsPerPage(Number(e.target.value))}
                    sx={{ width: 100 }}
                    inputProps={{ min: 1 }}
                />
            </Box>
            <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: 2, mt: 2 }}>
                <Table size="small">
                    <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Serie</TableCell>
                        <TableCell>Número</TableCell>
                        <TableCell>Cliente</TableCell>
                        <TableCell>Fecha Emisión</TableCell>
                        <TableCell>Vence</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Total</TableCell>
                        {refTab === 1 && <TableCell>Referencia</TableCell>}
                        <TableCell>Acciones</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {cotizacionesDisponibles.length === 0 && (
                        <TableRow><TableCell colSpan={refTab === 1 ? 9 : 8} align="center">
                          {refTab === 1 ? 'No hay cotizaciones ya referenciadas.' : 'No hay cotizaciones disponibles.'}
                        </TableCell></TableRow>
                    )}
                    {cotizacionesDisponibles.map(cot => (
                        <TableRow key={cot.id}>
                        <TableCell>
                            <Checkbox
                            checked={cotizacionesSeleccionadas.includes(cot.id)}
                            onChange={e => {
                                if (e.target.checked) {
                                setCotizacionesSeleccionadas(arr => [...arr, cot.id]);
                                } else {
                                setCotizacionesSeleccionadas(arr => arr.filter(id => id !== cot.id));
                                }
                            }}
                            />
                        </TableCell>
                        <TableCell>{cot.serie}</TableCell>
                        <TableCell>{cot.numero}</TableCell>
                        <TableCell>{clientes.find(x => x.id === cot.cliente_id)?.razon_social || cot.cliente_id}</TableCell>
                        <TableCell>{cot.fecha_emision?.substring(0, 10)}</TableCell>
                        <TableCell>{cot.fecha_validez?.substring(0, 10)}</TableCell>
                        <TableCell>{cot.estado}</TableCell>
                        <TableCell>{cot.total}</TableCell>
                        {refTab === 1 && (
                          <TableCell>
                            <IconButton
                              size="small"
                              title="Ver quién lo referenció (F1)"
                              tabIndex={0}
                              onClick={(e) => { setRefInfoAnchor(e.currentTarget); setRefInfoTexto(cot._referenciasResumen || 'Sin detalle.'); }}
                              onKeyDown={(e) => { if (e.key === 'F1') { e.preventDefault(); setRefInfoAnchor(e.currentTarget); setRefInfoTexto(cot._referenciasResumen || 'Sin detalle.'); } }}
                            >
                              <InfoIcon fontSize="small" color="primary" />
                            </IconButton>
                          </TableCell>
                        )}
                        <TableCell>
                            <Button size="small" onClick={() => setVistaCotizacion(cot)}>Vista previa</Button>
                        </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Popover
              open={!!refInfoAnchor}
              anchorEl={refInfoAnchor}
              onClose={() => setRefInfoAnchor(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
              <Box sx={{ p: 2, maxWidth: 320 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Ya referenciado por:</Typography>
                <Typography variant="body2">{refInfoTexto}</Typography>
              </Box>
            </Popover>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                <Typography variant="body2" sx={{ ml: 1 }}>
                    {cotizacionesDisponibles.length === 0
                    ? 'Mostrando 0-0 de 0 cotizaciones'
                    : `Mostrando ${cotizacionesPage * cotizacionesRowsPerPage + 1}-${Math.min((cotizacionesPage + 1) * cotizacionesRowsPerPage, cotizacionesDisponibles.length)} de ${cotizacionesDisponibles.length} cotizaciones`}
                </Typography>
                <Box>
                    <Button disabled={cotizacionesPage === 0} onClick={() => setCotizacionesPage(cotizacionesPage - 1)}>Anterior</Button>
                    <Button
                    disabled={cotizacionesRowsPerPage === -1 ? true : (cotizacionesPage + 1) * cotizacionesRowsPerPage >= cotizacionesDisponibles.length}
                    onClick={() => setCotizacionesPage(cotizacionesPage + 1)}
                    >Siguiente</Button>
                </Box>
            </Box>
            {vistaCotizacion && (
                <Dialog open={true} onClose={() => setVistaCotizacion(null)} maxWidth="xl" fullWidth>
                    <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: 20 }}>
                    Vista previa de Cotización
                    </DialogTitle>
                    <DialogContent>
                    <Box sx={{ mb: 2, p: 2, borderRadius: 2, background: '#f5f5f5', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                        <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Cliente:</Typography>
                            <Typography>{clientes.find(x => x.id === vistaCotizacion.cliente_id)?.razon_social || ''}</Typography>
                            <Typography variant="body2" color="text.secondary">RUC: {clientes.find(x => x.id === vistaCotizacion.cliente_id)?.numero_documento || ''}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Documento:</Typography>
                            <Typography>Serie: {vistaCotizacion.serie} Número: {vistaCotizacion.numero}</Typography>
                            <Typography variant="body2" color="text.secondary">Fecha Emisión: {vistaCotizacion.fecha_emision?.substring(0, 10) || ''}</Typography>
                            <Typography variant="body2" color="text.secondary">Vence: {vistaCotizacion.fecha_validez?.substring(0, 10) || ''}</Typography>
                            <Typography variant="body2" color="text.secondary">Moneda: {vistaCotizacion.moneda}</Typography>
                            <Typography variant="body2" color="text.secondary">Estado: {vistaCotizacion.estado}</Typography>
                        </Grid>
                        </Grid>
                        <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Detalle de productos:</Typography>
                        <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 1 }}>
                            <Table size="small">
                            <TableHead>
                                <TableRow>
                                <TableCell>Código</TableCell>
                                <TableCell>Producto</TableCell>
                                <TableCell>Almacén</TableCell>
                                <TableCell>Cantidad</TableCell>
                                <TableCell>U.Medida</TableCell>
                                <TableCell>Precio</TableCell>
                                <TableCell>Subtotal</TableCell>
                                <TableCell>IGV</TableCell>
                                <TableCell>Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(Array.isArray(vistaCotizacion.detalles) ? vistaCotizacion.detalles : (vistaCotizacion.detalles ? JSON.parse(vistaCotizacion.detalles) : [])).map((d, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{d.codigo_producto || productos.find(p => p.id === d.producto_id)?.codigo || ''}</TableCell>
                                    <TableCell>{d.descripcion_producto || productos.find(p => p.id === d.producto_id)?.nombre || ''}</TableCell>
                                    <TableCell>{almacenes.find(a => Number(a.id) === Number(d.almacen_id))?.nombre || ''}</TableCell>
                                    <TableCell>{d.cantidad}</TableCell>
                                    <TableCell>{d.unidad_medida}</TableCell>
                                    <TableCell>{d.precio_unitario}</TableCell>
                                    <TableCell>{d.subtotal}</TableCell>
                                    <TableCell>{d.igv_monto}</TableCell>
                                    <TableCell>{d.total}</TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                        </TableContainer>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Observaciones:</Typography>
                        <Typography>{vistaCotizacion.observaciones || '-'}</Typography>
                        </Box>
                    </Box>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => setVistaCotizacion(null)} color="error" variant="contained">Cerrar</Button>
                    </DialogActions>
                </Dialog>
                )}
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpenCotizaciones(false)} startIcon={<Cancel />} color="error" variant="contained">Cancelar</Button>
            <Button onClick={jalarCotizacionesSeleccionadas} variant="contained" color="primary" startIcon={<CheckCircle />}>
                Jalar seleccionadas
            </Button>
        </DialogActions>
    </Dialog>
    {/* ── Dialog: Emitir Comprobante desde NV ───────────────────────────────── */}
    <Dialog open={nvConvertirDialog} onClose={() => !nvConvertirLoading && setNvConvertirDialog(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold', bgcolor: '#1a237e', color: '#fff', display: 'flex', alignItems: 'center', gap: 1 }}>
        <SwapHoriz /> Emitir Comprobante — NV {nvConvertirDoc ? `${nvConvertirDoc.serie}-${String(nvConvertirDoc.numero).padStart(8,'0')}` : ''}
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
          Selecciona el tipo de comprobante electrónico y la serie a utilizar.
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>Tipo de comprobante</Typography>
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {[
            { tipo: 'FACTURA', label: 'Factura', desc: 'Comprobante (01) para empresas con RUC',    icon: <ReceiptLong sx={{ fontSize: 32 }} />, color: '#2e7d32', disabled: !/^\d{11}$/.test(clientes.find(x => x.id === nvConvertirDoc?.cliente_id)?.numero_documento || '') },
            { tipo: 'BOLETA',  label: 'Boleta',  desc: 'Comprobante (03) para personas naturales', icon: <Receipt sx={{ fontSize: 32 }} />,      color: '#e65100', disabled: false },
          ].map(({ tipo, label, desc, icon, color, disabled }) => (
            <Grid item xs={6} key={tipo}>
              <Tooltip title={disabled ? 'Requiere RUC — este cliente tiene DNI/CE, solo puede emitir Boleta' : ''} arrow>
                <span>
                  <Paper
                    elevation={nvConvertirTipo === tipo ? 6 : 1}
                    onClick={() => !disabled && handleNvConvertirTipo(tipo)}
                    sx={{
                      p: 2, textAlign: 'center', cursor: disabled ? 'not-allowed' : 'pointer', borderRadius: 3,
                      border: nvConvertirTipo === tipo ? `2.5px solid ${color}` : '2px solid transparent',
                      bgcolor: nvConvertirTipo === tipo ? `${color}14` : '#fafafa',
                      opacity: disabled ? 0.45 : 1,
                      transition: 'all .15s',
                      '&:hover': disabled ? {} : { bgcolor: `${color}0d`, borderColor: color },
                    }}
                  >
                    <Box sx={{ color, mb: 0.5 }}>{icon}</Box>
                    <Typography variant="body2" sx={{ fontWeight: 700, color }}>{label}</Typography>
                    <Typography variant="caption" color="text.secondary">{desc}</Typography>
                    {disabled && <Typography variant="caption" color="error" display="block" sx={{ mt: 0.5, fontWeight: 600 }}>Solo para clientes con RUC</Typography>}
                  </Paper>
                </span>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
        <TextField
          select fullWidth size="small" label="Serie"
          value={nvConvertirSerie}
          onChange={e => setNvConvertirSerie(e.target.value)}
          sx={{ mb: 2 }}
          helperText={nvSeriesConversion.length === 0 ? 'No hay series configuradas para este tipo' : ''}
          error={nvSeriesConversion.length === 0}
        >
          {nvSeriesConversion.map(s => (
            <MenuItem key={s.id} value={s.serie}>{s.serie} (siguiente: {s.correlativo_actual})</MenuItem>
          ))}
        </TextField>
        <Alert severity="info" sx={{ borderRadius: 2 }}>
          La Nota de Venta quedará marcada como <strong>FACTURADA</strong>. El comprobante se enviará a SUNAT automáticamente.
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setNvConvertirDialog(false)} disabled={nvConvertirLoading} color="inherit">Cancelar</Button>
        <Button
          variant="contained" onClick={handleNvConvertir}
          disabled={nvConvertirLoading || !nvConvertirSerie || nvSeriesConversion.length === 0}
          startIcon={nvConvertirLoading ? <CircularProgress size={16} color="inherit" /> : <SwapHoriz />}
          sx={{ bgcolor: '#1a237e', '&:hover': { bgcolor: '#283593' } }}
        >
          {nvConvertirLoading ? 'Emitiendo...' : 'Emitir Comprobante'}
        </Button>
      </DialogActions>
    </Dialog>

    {/* Snackbar NV */}
    <Snackbar open={nvSnackbar.open} autoHideDuration={6000} onClose={() => setNvSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert onClose={() => setNvSnackbar(s => ({ ...s, open: false }))} severity={nvSnackbar.severity} sx={{ width: '100%', fontWeight: 600 }}>
        {nvSnackbar.msg}
      </Alert>
    </Snackbar>

    <Dialog open={openNvPdfDialog} onClose={cerrarDialogoPdfNv} maxWidth="sm" fullWidth>
      <DialogTitle>Descargar PDF - Nota de Venta</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
          Selecciona el formato de impresión. El formato elegido puede quedar como predeterminado.
        </Alert>
        {nvPdfResolucionCargando ? (
          <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
            <Typography variant="body2">Resolviendo plantilla...</Typography>
          </Box>
        ) : nvPdfResolucion && nvPdfResolucion.plantilla_nombre ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            <Typography variant="body2"><strong>Plantilla:</strong> {nvPdfResolucion.plantilla_nombre}</Typography>
            <Typography variant="body2"><strong>Ámbito:</strong> {nvPdfResolucion.scope === 'Global' ? 'Global (todas las sucursales)' : nvPdfResolucion.scope === 'Specific' ? 'Específica para esta sucursal' : nvPdfResolucion.scope}</Typography>
            {nvPdfResolucion.is_inherited && (
              <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: '#1976d2' }}>
                Esta sucursal hereda la asignación de la configuración global
              </Typography>
            )}
          </Alert>
        ) : null}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, gap: 1.5, mb: 2 }}>
          {[
            { codigo: 'A4', titulo: 'A4', detalle: 'Formato completo' },
            { codigo: 'A5', titulo: 'A5', detalle: 'Formato compacto' },
            { codigo: 'T80', titulo: 'Ticket 80mm', detalle: 'Impresora térmica' }
          ].map((item) => (
            <Paper
              key={item.codigo}
              onClick={() => {
                setNvPdfFormatoSeleccionado(item.codigo);
                actualizarResolucionFormatoNv(item.codigo);
              }}
              sx={{
                p: 2,
                cursor: 'pointer',
                border: '2px solid',
                borderColor: nvPdfFormatoSeleccionado === item.codigo ? '#1976d2' : '#d0d7de',
                backgroundColor: nvPdfFormatoSeleccionado === item.codigo ? '#e3f2fd' : '#fff'
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center' }}>{item.titulo}</Typography>
              <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary' }}>{item.detalle}</Typography>
              {localStorage.getItem('nota_venta_pdf_formato_default') === item.codigo && (
                <Chip label="Predeterminado" color="primary" size="small" sx={{ mt: 1, display: 'flex', mx: 'auto', width: 'fit-content' }} />
              )}
            </Paper>
          ))}
        </Box>
        <FormControlLabel
          control={
            <Switch
              checked={guardarNvPdfComoPredeterminado}
              onChange={(e) => setGuardarNvPdfComoPredeterminado(e.target.checked)}
              color="primary"
            />
          }
          label={`Guardar ${nvPdfFormatoSeleccionado} como formato predeterminado`}
        />
        {nvPdfTarget && (
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
            Documento: {nvPdfTarget.serie}-{String(nvPdfTarget.numero || '').padStart(8, '0')}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={cerrarDialogoPdfNv}>Cancelar</Button>
        <Button onClick={descargarPdfNv} variant="contained">
          Descargar {nvPdfFormatoSeleccionado}
        </Button>
      </DialogActions>
    </Dialog>

    <ClienteRapidoDialog
      open={openNuevoCliente}
      onClose={() => setOpenNuevoCliente(false)}
      onClienteCreado={(cliente) => {
        debouncedFetchClientes.cancel();
        ++fetchClienteGenRef.current;
        setClientes(prev => [cliente, ...prev]);
        setForm(f => ({ ...f, cliente_id: cliente.id }));
        skipClienteSearch.current = true;
        setClienteInput(cliente.razon_social || '');
        setOpenNuevoCliente(false);
      }}
      initialQuery={clienteInput}
    />
    <ProductoRapidoDialog
      open={openNuevoProducto}
      onClose={() => setOpenNuevoProducto(false)}
      onProductoCreado={(producto) => {
        setProductos(prev => [producto, ...prev]);
        setDetalle(d => ({
          ...d,
          producto_id: producto.id,
          unidad_medida: producto.unidad_medida_id || d.unidad_medida,
          precio_unitario: producto.precio != null ? producto.precio : d.precio_unitario
        }));
        setProductoInput(producto?.nombre || '');
        setOpenNuevoProducto(false);
      }}
      initialNombre={productoInput}
    />
    <ProductoBuscadorDialog
      open={openBuscadorProducto}
      onClose={() => setOpenBuscadorProducto(false)}
      onSelect={handleBuscadorSelect}
    />
    <StockAlmacenesDialog
      open={openStockAlmacen}
      onClose={() => setOpenStockAlmacen(false)}
      productoId={detalle.producto_id}
      productoNombre={detalle.descripcion_producto}
    />
    </Box>
</Box>
  );
};
export default NotaVentaPage;
